/**
 * Custom Vinyl Product — Main JavaScript v1.6
 * Handles: Accordion, File Upload, Image Crop, Music Management,
 *          Dynamic Pricing, Preview Updates, Add to Cart
 */

(function () {
  'use strict';
  console.log('[Vinyl] Script v1.6 loaded — PYV method');

  const config = window.vinylConfigV2 || {};
  const FILESTACK_API_KEY = config.filestackApiKey || '';
  var _audioUploadQueue = Promise.resolve();
  var _cdnUploadQueue = Promise.resolve();

  var _isShopifyPayments = (config.currencyType === '1' || config.currencyType === 1);
  var _shopCurrency = config.shopCurrency || 'USD';
  var _cartCurrency = config.cartCurrency || _shopCurrency;
  var _isMultiCurrency = (_cartCurrency !== _shopCurrency);

  /* ==========================================================================
     STATE
     ========================================================================== */
  const state = {
    currentStep: 1,
    uploadedFiles: {},
    tracks: { A: [], B: [] },
    selectedRecord: null,
    step1Visited: false,
    recordColor: null,
    maxDuration: 7,
    maxTracks: 2,
    recordPriceAdd: 0,
    addonsTotal: 0,
    basePrice: config.basePrice || 0,
    discountRatio: config.discountRatio || 0.28,
    quantity: 1,
    uploadMode: null,
    customizationComplete: false,
    cropper: null,
    cropTargetIndex: null,
    cropOriginalFile: null,
    cropSourceMime: null,
    cropSourceName: null,
    coverText: {
      A:  { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 15, w: 50 },
      A2: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 45, w: 50 },
      A3: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 75, w: 50 },
      B:  { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 35, w: 50 },
      B2: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 53, w: 50 },
      B3: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 70, w: 50 },
      B4: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 85, w: 50 }
    },
    stickerText: {
      A: { text: '', font: 'Roboto', size: '10', lineHeight: '1.2', color: '#804040', placement: 'above', bold: false, italic: false, underline: false },
      B: { text: '', font: 'Roboto', size: '10', lineHeight: '1.2', color: '#804040', placement: 'below', bold: false, italic: false, underline: false }
    }
  };

  /* ==========================================================================
     SESSION PERSISTENCE — save/restore state across page refreshes
     ========================================================================== */
  var STORAGE_KEY = 'vinyl_customizer_state';
  var _saveTimer = null;

  function saveState() {
    if (_saveTimer) clearTimeout(_saveTimer);
    _saveTimer = setTimeout(function() {
      try {
        var snap = {
          selectedRecord: state.selectedRecord,
          step1Visited: state.step1Visited,
          recordColor: state.recordColor,
          recordPriceAdd: state.recordPriceAdd,
          maxDuration: state.maxDuration,
          maxTracks: state.maxTracks,
          uploadMode: state.uploadMode,
          quantity: state.quantity,
          coverText: state.coverText,
          stickerText: state.stickerText,
          tracks: {
            A: state.tracks.A.map(function(t) { return { name: t.name, durationStr: t.durationStr, durationSec: t.durationSec, fileUrl: (t.fileUrl && !t.fileUrl.startsWith('blob:')) ? t.fileUrl : '' }; }),
            B: state.tracks.B.map(function(t) { return { name: t.name, durationStr: t.durationStr, durationSec: t.durationSec, fileUrl: (t.fileUrl && !t.fileUrl.startsWith('blob:')) ? t.fileUrl : '' }; })
          },
          uploadedFiles: {}
        };
        Object.keys(state.uploadedFiles).forEach(function(k) {
          var f = state.uploadedFiles[k];
          if (!f) return;
          snap.uploadedFiles[k] = {
            name: f.name,
            resolution: f.resolution,
            origWidth: f.origWidth || 0,
            origHeight: f.origHeight || 0,
            previewUrl: f.fileUrl || f.previewUrl || '',
            fileUrl: f.fileUrl || f.previewUrl || ''
          };
        });
        var addons = [];
        document.querySelectorAll('.vinyl-addon input[type="checkbox"]').forEach(function(cb) {
          if (cb.checked) addons.push(cb.id || cb.value);
        });
        snap.addons = addons;
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snap));
      } catch (e) { /* quota exceeded — ignore */ }
    }, 300);
  }

  function restoreState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var snap = JSON.parse(raw);
      if (!snap) return false;

      if (snap.step1Visited) state.step1Visited = true;
      if (snap.selectedRecord) {
        state.selectedRecord = snap.selectedRecord;
        state.recordPriceAdd = snap.recordPriceAdd || 0;
        state.maxDuration = snap.maxDuration || 7;
        state.maxTracks = snap.maxTracks || 2;
        var radio = null;
        document.querySelectorAll('input[name="Record option"]').forEach(function(r) {
          if (r.value === snap.selectedRecord) radio = r;
        });
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (snap.recordColor) {
        state.recordColor = snap.recordColor;
        if (recordPickr) recordPickr.setColor(snap.recordColor);
        if (typeof applyVinylColor === 'function') applyVinylColor(snap.recordColor);
      }

      if (snap.coverText) {
        ['A', 'A2', 'A3', 'B', 'B2', 'B3', 'B4'].forEach(function(k) {
          if (!snap.coverText[k]) return;
          var d = snap.coverText[k];
          state.coverText[k] = Object.assign(state.coverText[k], d);
          var ti = document.getElementById('coverText' + k);
          var fs = document.getElementById('coverFont' + k);
          var ss = document.getElementById('coverSize' + k);
          var lh = document.getElementById('coverLineHeight' + k);
          var ci = document.getElementById('coverColor' + k);
          var cp = document.getElementById('coverColorPreview' + k);
          if (pickrInstances[k] && d.color) {
            pickrInstances[k].setColor(d.color);
          }
          var wr = document.getElementById('coverWidth' + k);
          var wv = document.getElementById('coverWidthVal' + k);
          if (ti) ti.value = d.text || '';
          if (fs) fs.value = d.font || 'Roboto';
          if (ss) ss.value = d.size || '24';
          if (lh) lh.value = d.lineHeight || '1.2';
          if (ci) ci.value = d.color || '#804040';
          if (cp) cp.style.background = d.color || '#804040';
          if (wr) wr.value = d.w || 50;
          if (wv) wv.textContent = (d.w || 50) + '%';

          var fg = document.querySelector('.vinyl-text-field-group[data-field-key="' + k + '"]');
          if (fg) {
            var btns = fg.querySelectorAll('.vinyl-format-btn');
            btns.forEach(function(btn) {
              var fmt = btn.dataset.format;
              if (d[fmt]) btn.classList.add('vinyl-format-btn--active');
            });
          }
        });
      }

      if (snap.stickerText) {
        ['A', 'B'].forEach(function(k) {
          if (!snap.stickerText[k]) return;
          var d = snap.stickerText[k];
          state.stickerText[k] = Object.assign(state.stickerText[k], d);
          var ti = document.getElementById('stickerText' + k);
          var fs = document.getElementById('stickerFont' + k);
          var ss = document.getElementById('stickerSize' + k);
          var ci = document.getElementById('stickerColor' + k);
          var cp = document.getElementById('stickerColorPreview' + k);
          if (ti) ti.value = d.text || '';
          if (fs) fs.value = d.font || 'Roboto';
          if (ss) ss.value = d.size || '10';
          if (ci) ci.value = d.color || '#804040';
          if (cp) cp.style.background = d.color || '#804040';
          var plBtns = document.querySelectorAll('.vinyl-placement-btn[data-placement-target="sticker' + k + '"]');
          plBtns.forEach(function(btn) {
            btn.classList.toggle('vinyl-placement-btn--active', btn.dataset.placement === d.placement);
          });
        });
      }

      if (snap.tracks) {
        state.tracks = snap.tracks;
      }

      if (snap.uploadedFiles) {
        Object.keys(snap.uploadedFiles).forEach(function(k) {
          var f = snap.uploadedFiles[k];
          if (!f || !f.fileUrl) return;
          showUploadedFile(parseInt(k, 10), f.name, f.resolution, f.fileUrl, f.fileUrl, f.origWidth, f.origHeight);
          if (f.origWidth && f.origHeight) {
            updateDpiBadge(parseInt(k, 10), f.origWidth, f.origHeight);
          }
        });
      }

      if (snap.uploadMode) {
        state.uploadMode = snap.uploadMode;
        var modeRadio = document.querySelector('input[name="upload_mode"][value="' + snap.uploadMode + '"]');
        if (modeRadio) {
          modeRadio.checked = true;
          modeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (snap.quantity && snap.quantity > 1) {
        state.quantity = snap.quantity;
        if (dom.quantityInput) dom.quantityInput.value = snap.quantity;
      }

      if (snap.addons && snap.addons.length) {
        snap.addons.forEach(function(id) {
          var cb = document.getElementById(id) || document.querySelector('.vinyl-addon input[value="' + id + '"]');
          if (cb && !cb.checked) {
            cb.checked = true;
            cb.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      return true;
    } catch (e) {
      return false;
    }
  }

  /* ==========================================================================
     DOM REFERENCES
     ========================================================================== */
  const dom = {
    accordion: document.getElementById('vinyl-accordion'),
    steps: null,
    stepHeaders: null,
    submitBtn: document.getElementById(`VinylSubmitButton-${config.sectionId}`),
    shopPayBtn: document.querySelector('.vinyl-btn--shop-pay'),
    priceDisplay: document.querySelector('.vinyl-price__current .money'),
    compareDisplay: document.querySelector('.vinyl-price__compare .money'),
    discountPercent: document.querySelector('.vinyl-discount-percent'),
    discountBadge: document.querySelector('.vinyl-price__badge'),
    savingsAmount: document.querySelector('.vinyl-savings__amount .money'),
    savingsTotal: document.querySelector('.vinyl-savings__total'),
    installmentAmount: document.querySelector('.vinyl-installment-amount'),
    quantityInput: document.getElementById('vinyl-quantity-input'),
    quantityMinus: null,
    quantityPlus: null,
    variantInput: document.querySelector('.product-variant-id'),
    cropModal: document.getElementById('vinylCropModal'),
    cropImage: document.getElementById('vinyl-crop-image'),
    cropConfirm: document.getElementById('vinyl-crop-confirm'),
    cropCancel: document.getElementById('vinyl-crop-cancel'),
    previewSlides: document.querySelectorAll('.vinyl-preview__slide'),
    previewThumbs: document.querySelectorAll('.vinyl-preview__thumb'),
    shippingDays: document.querySelector('.shipping_days')
  };

  /* ==========================================================================
     SAFARI ASPECT-RATIO FIX
     ========================================================================== */
  function fixSafariPreview() {
    if (!window.__safariVinylFix) return;
    var slidesEl = document.querySelector('.vinyl-preview__slides');
    if (slidesEl && !slidesEl.classList.contains('vinyl-preview__slides--hero')) {
      var sw = slidesEl.offsetWidth;
      if (sw > 0) slidesEl.style.height = sw + 'px';
    } else if (slidesEl) {
      slidesEl.style.height = '';
    }

    document.querySelectorAll('.vinyl-preview__slide').forEach(function(slide) {
      var rec = slide.querySelector('.vinyl-preview__record');
      if (!rec) return;
      var parent = slide.closest('.vinyl-preview__slides');
      if (parent && !parent.classList.contains('vinyl-preview__slides--hero')) {
        var ph = parent.offsetHeight || parent.offsetWidth;
        if (ph > 0) rec.style.height = ph + 'px';
      }
    });

    document.querySelectorAll('.vinyl-preview__vinyl:not(.vinyl-preview__vinyl--grid)').forEach(function(v) {
      var w = v.offsetWidth;
      if (w > 0) v.style.height = w + 'px';
    });

    document.querySelectorAll('.vinyl-preview__full-cell').forEach(function(cell) {
      var cw = cell.offsetWidth;
      if (cw > 0) cell.style.height = cw + 'px';
    });
  }

  /* ==========================================================================
     INITIALIZATION
     ========================================================================== */
  function init() {
    if (!dom.accordion) return;

    dom.steps = dom.accordion.querySelectorAll('.vinyl-step');
    dom.stepHeaders = dom.accordion.querySelectorAll('.vinyl-step__header');

    const qControls = document.querySelector('.vinyl-quantity__controls');
    if (qControls) {
      dom.quantityMinus = qControls.querySelector('[name="minus"]');
      dom.quantityPlus = qControls.querySelector('[name="plus"]');
    }

    bindAccordion();
    bindUploaders();
    bindRecordOptions();
    bindRecordColorPalette();
    bindUploadMode();
    bindAddons();
    bindQuantity();
    bindCropModal();
    bindPreviewThumbs();
    bindModals();
    bindMobilePreview();
    bindCoverTextUI();
    bindStickerTextUI();
    initSpectrumPickers();
    bindPositionGrids();
    bindPlacementButtons();
    bindFormatToolbars();
    applyFontPreviews();

    var restored = restoreState();

    if (restored) {
      ALL_COVER_KEYS.forEach(function(k) {
        if (state.coverText[k] && state.coverText[k].text) {
          preloadFont(state.coverText[k].font, state.coverText[k].bold, state.coverText[k].italic);
          updateCoverTextPreview(k);
        }
      });
      ['A', 'B'].forEach(function(k) {
        if (state.stickerText[k] && state.stickerText[k].text) {
          preloadFont(state.stickerText[k].font, state.stickerText[k].bold, state.stickerText[k].italic);
          updateStickerTextPreview(k);
        }
      });
      restoreTrackListUI();
    }

    if (!state.selectedRecord) {
      var firstRadio = document.querySelector('input[name="Record option"]:not(:disabled)');
      if (firstRadio) {
        firstRadio.checked = true;
        firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (_isShopifyPayments && _isMultiCurrency) {
      convertRecordLabels();
    }

    updatePriceDisplay();
    checkCustomizationStatus();

    document.addEventListener('currency:update', function() {
      if (window._vinylCurrencyUpdating) return;
      updatePriceDisplay();
    });

    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    window.__safariVinylFix = isSafari;

    if (isSafari) {
      fixSafariPreview();
      window.addEventListener('resize', fixSafariPreview);
      setTimeout(fixSafariPreview, 200);
      setTimeout(fixSafariPreview, 800);

      var previewObserver = new MutationObserver(function() { setTimeout(fixSafariPreview, 50); });
      var slidesObs = document.querySelector('.vinyl-preview__slides');
      if (slidesObs) previewObserver.observe(slidesObs, { attributes: true, attributeFilter: ['class'] });
      document.querySelectorAll('.vinyl-preview__slide').forEach(function(slide) {
        previewObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }

    var frontCover = document.querySelector('.vinyl-preview__cover--front');
    if (frontCover) {
      var frontImg = frontCover.querySelector('.vinyl-preview__image');
      if (frontImg && frontImg.getAttribute('src') && frontImg.style.display !== 'none') {
        frontCover.classList.add('vinyl-preview__cover--has-image');
      }
    }
  }

  /* ==========================================================================
     STEP ↔ PREVIEW MAPPING (7 steps)
     Step 1 (record)       → vinyl-a
     Step 2 (cover)        → front-cover
     Step 3 (cover text)   → front-cover
     Step 4 (sticker)      → vinyl-a
     Step 5 (sticker text) → vinyl-a
     Step 6 (music)        → vinyl-b
     Step 7 (extras)       → full-set
     ========================================================================== */
  const STEP_TO_PREVIEW = { 1: 'vinyl-a', 2: 'front-cover', 3: 'front-cover', 4: 'vinyl-a', 5: 'vinyl-a', 6: 'vinyl-b', 7: 'full-set' };
  const PREVIEW_TO_STEP = { 'front-cover': 2, 'back-cover': 2, 'vinyl-a': 4, 'vinyl-b': 4, 'full-set': 7 };

  /* ==========================================================================
     ACCORDION (CSS-only animation via grid-template-rows)
     ========================================================================== */
  function exitHeroMode() {
    var slidesContainer = document.querySelector('.vinyl-preview__slides');
    if (!slidesContainer) return;
    var wasHero = slidesContainer.classList.contains('vinyl-preview__slides--hero');
    slidesContainer.classList.remove('vinyl-preview__slides--hero');

    if (wasHero) {
      var frontCover = document.querySelector('.vinyl-preview__cover--front');
      if (frontCover) {
        var img = frontCover.querySelector('.vinyl-preview__image');
        if (img && img.hasAttribute('data-is-product-featured') && !state.uploadedFiles[1]) {
          img.style.display = 'none';
          var ph = frontCover.querySelector('.vinyl-preview__placeholder');
          if (ph) ph.style.display = '';
          frontCover.classList.remove('vinyl-preview__cover--has-image');
        }
      }
    }
    if (window.__safariVinylFix) setTimeout(fixSafariPreview, 30);
  }

  function bindAccordion() {
    dom.stepHeaders.forEach((header) => {
      header.addEventListener('click', () => {
        exitHeroMode();

        const step = header.closest('.vinyl-step');
        const stepNum = parseInt(step.dataset.step, 10);
        const isActive = step.classList.contains('vinyl-step--active');

        if (stepNum === 1 && !state.step1Visited) {
          state.step1Visited = true;
          checkCustomizationStatus();
          saveState();
        }

        var allContents = document.querySelectorAll('.vinyl-step__content');
        allContents.forEach(function(c) { c.style.transition = 'none'; });

        var headerTopBefore = header.getBoundingClientRect().top;

        dom.steps.forEach((s) => {
          if (s !== step) s.classList.remove('vinyl-step--active');
        });

        if (isActive) {
          step.classList.remove('vinyl-step--active');
        } else {
          step.classList.add('vinyl-step--active');
          switchPreviewForStep(stepNum);
        }

        updateMediaSticky();

        requestAnimationFrame(function() {
          allContents.forEach(function(c) { c.style.transition = ''; });
        });

        var anchorY = headerTopBefore;
        var t0 = performance.now();
        (function pin() {
          var cur = header.getBoundingClientRect().top;
          var diff = cur - anchorY;
          if (Math.abs(diff) > 1) window.scrollBy(0, diff);
          if (performance.now() - t0 < 450) requestAnimationFrame(pin);
        })();
      });
    });
  }

  function switchPreviewForStep(stepNum) {
    const target = STEP_TO_PREVIEW[stepNum];
    if (!target) return;
    activatePreviewSlide(target);
  }

  function activatePreviewSlide(slideId) {
    exitHeroMode();

    dom.previewThumbs.forEach((t) => t.classList.remove('vinyl-preview__thumb--active'));
    dom.previewSlides.forEach((s) => s.classList.remove('vinyl-preview__slide--active'));

    const targetSlide = document.querySelector(`.vinyl-preview__slide[data-slide="${slideId}"]`);
    const targetThumb = document.querySelector(`.vinyl-preview__thumb[data-target="${slideId}"]`);
    if (targetSlide) targetSlide.classList.add('vinyl-preview__slide--active');
    if (targetThumb) targetThumb.classList.add('vinyl-preview__thumb--active');

    if (slideId === 'full-set') {
      refreshFullSetTextOverlays();
    }
  }

  function refreshFullSetTextOverlays() {
    ['A', 'B'].forEach(function(side) {
      updateCoverTextPreview(side);
      updateStickerTextPreview(side);
    });
  }

  
  /* ==========================================================================
     MEDIA STICKY TOGGLE
     ========================================================================== */
  function updateMediaSticky() {
    var media = document.querySelector('.vinyl-product__media');
    if (!media) return;

    var hasActiveStep = dom.accordion && dom.accordion.querySelector('.vinyl-step--active');
    if (hasActiveStep) {
      media.classList.add('vinyl-product__media--sticky');
    } else {
      media.classList.remove('vinyl-product__media--sticky');
    }
  }

  function openStepByNumber(stepNum) {
    const step = document.getElementById('step' + stepNum);
    if (!step) return;
    if (step.classList.contains('vinyl-step--active')) return;

    exitHeroMode();

    dom.steps.forEach((s) => {
      if (s !== step) s.classList.remove('vinyl-step--active');
    });

    step.classList.add('vinyl-step--active');
    switchPreviewForStep(stepNum);
    updateMediaSticky();
  }

  /* ==========================================================================
     FILE UPLOAD SYSTEM
     ========================================================================== */
  function bindUploaders() {
    const uploaders = document.querySelectorAll('.vinyl-uploader');

    uploaders.forEach((uploader) => {
      const index = parseInt(uploader.dataset.index, 10);
      const dropArea = uploader.querySelector('.vinyl-dropzone-modal__area');
      const label = uploader.querySelector('label');

      label.addEventListener('click', (e) => {
        e.preventDefault();
        openUploadModal(uploader, index);
      });
    });

    const musicUploaders = document.querySelectorAll('.vinyl-music-uploader');
    musicUploaders.forEach((uploader) => {
      const uploadLabel = uploader.querySelector('.vinyl-music-uploader__upload');
      const manualLabel = uploader.querySelector('.vinyl-music-uploader__manual');
      const index = parseInt(uploader.dataset.index, 10);

      if (uploadLabel) {
        uploadLabel.addEventListener('click', (e) => {
          e.preventDefault();
          if (state.uploadMode === 'Own Files') {
            openMusicUploadModal(uploader, index);
          }
        });
      }

      if (manualLabel) {
        manualLabel.addEventListener('click', (e) => {
          e.preventDefault();
          openManualSongEntry(uploader, index);
        });
      }
    });

    document.querySelectorAll('.vinyl-uploaded-file__delete').forEach((btn) => {
      btn.addEventListener('click', () => {
        const fileEl = btn.closest('.vinyl-uploaded-file');
        const index = parseInt(fileEl.dataset.index, 10);
        deleteUploadedFile(index);
      });
    });

    document.querySelectorAll('.vinyl-uploaded-file__edit').forEach((btn) => {
      btn.addEventListener('click', () => {
        const fileEl = btn.closest('.vinyl-uploaded-file');
        const index = parseInt(fileEl.dataset.index, 10);
        editUploadedFile(index);
      });
    });
  }

  function openUploadModal(uploader, index) {
    const modalWrapper = uploader.querySelector('.vinyl-upload-modal-wrapper');
    if (!modalWrapper) return;

    modalWrapper.classList.add('active');
    const dropArea = modalWrapper.querySelector('.vinyl-dropzone-modal__area');

    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/jpeg,image/png,image/webp,application/pdf,image/tiff,.heic';
    fileInput.style.display = 'none';

    const handleFile = (file) => {
      modalWrapper.classList.remove('active');
      processImageFile(file, index);
    };

    fileInput.addEventListener('change', (e) => {
      if (e.target.files.length > 0) {
        handleFile(e.target.files[0]);
      }
      fileInput.remove();
    });

    if (dropArea) {
      const clickHandler = (e) => {
        e.stopPropagation();
        fileInput.click();
      };
      dropArea.addEventListener('click', clickHandler, { once: true });

      dropArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        dropArea.classList.add('dragover');
      });

      dropArea.addEventListener('dragleave', () => {
        dropArea.classList.remove('dragover');
      });

      dropArea.addEventListener('drop', (e) => {
        e.preventDefault();
        dropArea.classList.remove('dragover');
        if (e.dataTransfer.files.length > 0) {
          handleFile(e.dataTransfer.files[0]);
        }
      });
    }

    const closeBtn = modalWrapper.querySelector('.vinyl-dropzone-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        modalWrapper.classList.remove('active');
      }, { once: true });
    }

    modalWrapper.addEventListener('click', (e) => {
      if (e.target === modalWrapper) {
        modalWrapper.classList.remove('active');
      }
    });

    document.body.appendChild(fileInput);
  }

  var ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf', 'image/tiff'];
  var MAX_FILE_BYTES = { cover: 15728640, label: 8388608 };

  function getMaxBytes(index) {
    return (index <= 2) ? MAX_FILE_BYTES.cover : MAX_FILE_BYTES.label;
  }

  function extFromMime(mime) {
    if (!mime) return 'jpg';
    if (mime.indexOf('png') !== -1) return 'png';
    if (mime.indexOf('webp') !== -1) return 'webp';
    return 'jpg';
  }

  function mimeFromFilename(name) {
    if (!name) return null;
    var lower = String(name).toLowerCase();
    if (lower.indexOf('.png') !== -1) return 'image/png';
    if (lower.indexOf('.webp') !== -1) return 'image/webp';
    if (lower.indexOf('.jpg') !== -1 || lower.indexOf('.jpeg') !== -1) return 'image/jpeg';
    return null;
  }

  function normalizeOutputMime(sourceMime) {
    if (!sourceMime) return 'image/jpeg';
    var m = String(sourceMime).toLowerCase();
    if (m.indexOf('png') !== -1) return 'image/png';
    if (m.indexOf('webp') !== -1) return 'image/webp';
    return 'image/jpeg';
  }

  function encodeCanvasPreservingFormat(canvas, sourceMime, maxBytes) {
    var outMime = normalizeOutputMime(sourceMime);
    return new Promise(function(resolve) {
      function readerOf(blob, mime) {
        var reader = new FileReader();
        reader.onload = function() {
          resolve({ dataUrl: reader.result, width: canvas.width, height: canvas.height, mime: mime, size: blob.size });
        };
        reader.readAsDataURL(blob);
      }
      function tryEncode(mime, quality, onDone, onFail) {
        canvas.toBlob(function(blob) {
          if (!blob) { onFail(); return; }
          onDone(blob);
        }, mime, quality);
      }
      if (outMime === 'image/png') {
        tryEncode('image/png', undefined, function(blob) {
          var sizeKB = (blob.size / 1024).toFixed(0);
          console.log('[Vinyl] PNG lossless → ' + sizeKB + 'KB (' + canvas.width + 'x' + canvas.height + ')');
          if (blob.size <= maxBytes) { readerOf(blob, 'image/png'); return; }
          console.warn('[Vinyl] PNG ' + sizeKB + 'KB exceeds limit, falling back to JPEG q=0.95');
          tryEncode('image/jpeg', 0.95, function(jb) { readerOf(jb, 'image/jpeg'); }, function() { readerOf(blob, 'image/png'); });
        }, function() {
          tryEncode('image/jpeg', 0.95, function(jb) { readerOf(jb, 'image/jpeg'); }, function() {
            resolve({ dataUrl: canvas.toDataURL('image/jpeg', 0.95), width: canvas.width, height: canvas.height, mime: 'image/jpeg', size: 0 });
          });
        });
        return;
      }
      var quality = 0.95;
      var minQuality = 0.75;
      function attempt() {
        tryEncode(outMime, quality, function(blob) {
          var sizeKB = (blob.size / 1024).toFixed(0);
          var limitKB = (maxBytes / 1024).toFixed(0);
          console.log('[Vinyl] Encode ' + outMime + ' q=' + quality.toFixed(2) + ' → ' + sizeKB + 'KB / ' + limitKB + 'KB (' + canvas.width + 'x' + canvas.height + ')');
          if (blob.size <= maxBytes || quality <= minQuality) { readerOf(blob, outMime); return; }
          quality = Math.max(minQuality, quality - 0.05);
          attempt();
        }, function() {
          resolve({ dataUrl: canvas.toDataURL(outMime, quality), width: canvas.width, height: canvas.height, mime: outMime, size: 0 });
        });
      }
      attempt();
    });
  }

  /* ==========================================================================
     PDF / TIFF PASSTHROUGH
     The customer's original PDF/TIFF must arrive in the order untouched.
     We render the first page to a PNG only as a UI thumbnail / live-preview;
     the cart line item property points at the ORIGINAL file on Filestack.
     ========================================================================== */
  var __vinylScriptCache = {};
  function loadScriptOnce(src) {
    if (!src) return Promise.reject(new Error('Missing script URL'));
    if (__vinylScriptCache[src]) return __vinylScriptCache[src];
    __vinylScriptCache[src] = new Promise(function(resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function() { resolve(); };
      s.onerror = function() { reject(new Error('Failed to load ' + src)); };
      document.head.appendChild(s);
    });
    return __vinylScriptCache[src];
  }

  function ensurePdfJs() {
    if (typeof window.pdfjsLib !== 'undefined') {
      if (config.pdfWorkerUrl && window.pdfjsLib.GlobalWorkerOptions && !window.pdfjsLib.GlobalWorkerOptions.workerSrc) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = config.pdfWorkerUrl;
      }
      return Promise.resolve(window.pdfjsLib);
    }
    return loadScriptOnce(config.pdfJsUrl).then(function() {
      if (window.pdfjsLib && config.pdfWorkerUrl) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = config.pdfWorkerUrl;
      }
      return window.pdfjsLib;
    });
  }

  function ensureUtif() {
    if (typeof window.UTIF !== 'undefined') return Promise.resolve(window.UTIF);
    return loadScriptOnce(config.utifUrl).then(function() { return window.UTIF; });
  }

  function isPdfOrTiffFile(file) {
    if (!file) return null;
    var name = (file.name || '').toLowerCase();
    var mime = (file.type || '').toLowerCase();
    if (mime === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
    if (mime === 'image/tiff' || mime === 'image/tif' || name.endsWith('.tif') || name.endsWith('.tiff')) return 'tiff';
    return null;
  }

  function detectPassthroughMime(file) {
    var kind = isPdfOrTiffFile(file);
    if (kind === 'pdf')  return 'application/pdf';
    if (kind === 'tiff') return 'image/tiff';
    return file && file.type ? file.type : 'application/octet-stream';
  }

  function renderPdfFirstPageToPngDataUrl(file) {
    return ensurePdfJs().then(function() {
      return file.arrayBuffer();
    }).then(function(buf) {
      return window.pdfjsLib.getDocument({ data: new Uint8Array(buf) }).promise;
    }).then(function(pdf) {
      if (pdf.numPages > 1) {
        console.log('[Vinyl PDF] file has', pdf.numPages, 'pages — preview = page 1, original PDF (all pages) goes to order');
      }
      return pdf.getPage(1);
    }).then(function(page) {
      var raw = page.getViewport({ scale: 1 });
      var maxDim = 1600;
      var scale = Math.min(maxDim / Math.max(raw.width, raw.height), 2);
      if (!isFinite(scale) || scale <= 0) scale = 1;
      var viewport = page.getViewport({ scale: scale });
      var canvas = document.createElement('canvas');
      canvas.width  = Math.max(1, Math.round(viewport.width));
      canvas.height = Math.max(1, Math.round(viewport.height));
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      return page.render({ canvasContext: ctx, viewport: viewport }).promise.then(function() {
        return canvas.toDataURL('image/png');
      });
    });
  }

  function renderTiffFirstPageToPngDataUrl(file) {
    return ensureUtif().then(function() {
      return file.arrayBuffer();
    }).then(function(buf) {
      var bytes = new Uint8Array(buf);
      var ifds = window.UTIF.decode(bytes);
      if (!ifds || !ifds.length) throw new Error('Empty TIFF');
      if (ifds.length > 1) {
        console.log('[Vinyl TIFF] file has', ifds.length, 'images — preview = first, original TIFF goes to order');
      }
      window.UTIF.decodeImage(bytes, ifds[0]);
      var w = ifds[0].width, h = ifds[0].height;
      if (!w || !h) throw new Error('TIFF has no dimensions');
      var rgba = window.UTIF.toRGBA8(ifds[0]);
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      var ctx = canvas.getContext('2d');
      var imageData = ctx.createImageData(w, h);
      imageData.data.set(rgba);
      ctx.putImageData(imageData, 0, 0);
      return canvas.toDataURL('image/png');
    });
  }

  function makePlaceholderPreviewDataUrl(label) {
    var canvas = document.createElement('canvas');
    canvas.width = 600; canvas.height = 600;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = '#F4F4F4'; ctx.fillRect(0, 0, 600, 600);
    ctx.fillStyle = '#999999';
    ctx.font = 'bold 80px Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(String(label || 'FILE').toUpperCase(), 300, 300);
    return canvas.toDataURL('image/png');
  }

  function registerPassthroughUpload(index, originalFile, previewDataUrl, originalFileUrl) {
    var fileEl  = document.querySelector('.vinyl-uploaded-file[data-index="' + index + '"]');
    var uploader = document.querySelector('.vinyl-uploader[data-index="' + index + '"]');
    if (fileEl) {
      fileEl.classList.remove('visually-hidden');
      var previewImg = fileEl.querySelector('.preview_img');
      if (previewImg) previewImg.src = previewDataUrl;
    }
    if (uploader) uploader.style.display = 'none';

    var hiddenInput = document.querySelector('input[data-index="' + index + '"].add_image');
    if (hiddenInput) hiddenInput.value = '';

    var passthroughMime = detectPassthroughMime(originalFile);

    // upload.blob = ORIGINAL pdf/tiff File (not the PNG preview) so that
    // if Filestack/CDN ever fails to return a URL, the cart's multipart
    // /cart/add upload still delivers the customer's original file.
    state.uploadedFiles[index] = {
      name: originalFile.name || 'file',
      resolution: '',
      origWidth: 0,
      origHeight: 0,
      previewUrl: previewDataUrl,
      fileUrl: originalFileUrl,
      blob: originalFile,
      mime: passthroughMime,
      isPassthrough: true
    };
    precacheImageForCanvas(index);
    updatePreview(index, previewDataUrl);
    checkCustomizationStatus();
    saveState();
  }

  function handlePassthroughFile(file, index) {
    var kind = isPdfOrTiffFile(file);
    if (!kind) return false;
    showConvertingState(index, true);

    var renderPromise = (kind === 'pdf')
      ? renderPdfFirstPageToPngDataUrl(file).catch(function(err) {
          console.warn('[Vinyl PDF] render failed, using placeholder:', err && err.message || err);
          return makePlaceholderPreviewDataUrl('PDF');
        })
      : renderTiffFirstPageToPngDataUrl(file).catch(function(err) {
          console.warn('[Vinyl TIFF] render failed, using placeholder:', err && err.message || err);
          return makePlaceholderPreviewDataUrl('TIFF');
        });

    renderPromise.then(function(previewDataUrl) {
      return uploadBlobToFilestack(file, file.name).then(function(result) {
        showConvertingState(index, false);
        var resolvedFileUrl = (typeof result === 'string' && result.indexOf('://') !== -1)
          ? result
          : previewDataUrl;
        console.log('[Vinyl] ' + kind.toUpperCase() + ' passthrough uploaded — order link:', resolvedFileUrl);
        registerPassthroughUpload(index, file, previewDataUrl, resolvedFileUrl);
      });
    }).catch(function(err) {
      showConvertingState(index, false);
      console.error('[Vinyl] ' + kind.toUpperCase() + ' passthrough failed:', err);
      alert('Failed to upload ' + kind.toUpperCase() + ' file: ' + (err && err.message || err));
    });
    return true;
  }

  function processImageFile(file, index) {
    var ext = file.name.toLowerCase().split('.').pop();
    if (ext === 'heic' || ext === 'heif') {
      showConvertingState(index, true);
      if (typeof heic2any !== 'undefined') {
        heic2any({ blob: file, toType: 'image/png' })
          .then((convertedBlob) => {
            showConvertingState(index, false);
            var converted = new File([convertedBlob], 'converted_' + Date.now() + '.png', { type: 'image/png' });
            openCropModal(converted, index, converted);
          })
          .catch(() => {
            showConvertingState(index, false);
            alert('Failed to convert HEIC file. Please use a JPEG or PNG.');
          });
      } else {
        showConvertingState(index, false);
        alert('HEIC conversion not available. Please use JPEG, PNG, or WebP.');
      }
      return;
    }

    if (isPdfOrTiffFile(file)) {
      handlePassthroughFile(file, index);
      return;
    }

    var mimeType = file.type ? file.type.toLowerCase() : '';
    if (mimeType && ALLOWED_MIME_TYPES.indexOf(mimeType) === -1) {
      alert('Unsupported file format: ' + (mimeType || ext) + '.\nAllowed: JPEG, PNG, WebP, PDF, TIFF.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      openCropModal(e.target.result, index, file);
    };
    reader.readAsDataURL(file);
  }

  function showConvertingState(index, show) {
    const uploader = document.querySelector(`.vinyl-uploader[data-index="${index}"]`);
    if (!uploader) return;
    const converting = uploader.querySelector('.vinyl-dropzone-modal__converting');
    const labels = uploader.querySelector('.vinyl-dropzone-modal__labels');
    if (converting) converting.style.display = show ? 'flex' : 'none';
  }

  function deleteUploadedFile(index) {
    const fileEl = document.querySelector(`.vinyl-uploaded-file[data-index="${index}"]`);
    const uploader = document.querySelector(`.vinyl-uploader[data-index="${index}"]`);

    if (fileEl) fileEl.classList.add('visually-hidden');
    if (uploader) uploader.style.display = '';

    var badge = document.querySelector('.vinyl-dpi-badge[data-index="' + index + '"]');
    if (badge) { badge.className = 'vinyl-dpi-badge visually-hidden'; badge.textContent = ''; }

    delete state.uploadedFiles[index];

    const hiddenInput = document.querySelector(`input[data-index="${index}"].add_image`);
    if (hiddenInput) hiddenInput.value = '';

    updatePreview(index, null);
    checkCustomizationStatus();
  }

  function editUploadedFile(index) {
    const uploader = document.querySelector(`.vinyl-uploader[data-index="${index}"]`);
    if (!uploader) return;

    var wasHidden = uploader.style.display === 'none';
    if (wasHidden) uploader.style.display = '';

    openUploadModal(uploader, index);

    if (wasHidden) {
      var wrapper = uploader.querySelector('.vinyl-upload-modal-wrapper');
      if (wrapper) {
        var obs = new MutationObserver(function() {
          if (!wrapper.classList.contains('active')) {
            uploader.style.display = 'none';
            obs.disconnect();
          }
        });
        obs.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  function showUploadedFile(index, fileName, resolution, previewUrl, fileUrl, origW, origH, mimeType) {
    const fileEl = document.querySelector(`.vinyl-uploaded-file[data-index="${index}"]`);
    const uploader = document.querySelector(`.vinyl-uploader[data-index="${index}"]`);

    if (!fileEl) return;

    fileEl.classList.remove('visually-hidden');
    if (uploader) uploader.style.display = 'none';

    const previewImg = fileEl.querySelector('.preview_img');
    if (previewImg) previewImg.src = previewUrl;

    const hiddenInput = document.querySelector(`input[data-index="${index}"].add_image`);
    if (hiddenInput) hiddenInput.value = '';

    var resolvedMime = mimeType || mimeFromFilename(fileName) || 'image/jpeg';
    state.uploadedFiles[index] = {
      name: fileName,
      resolution,
      origWidth: origW || 0,
      origHeight: origH || 0,
      previewUrl,
      fileUrl: fileUrl || previewUrl,
      blob: null,
      mime: resolvedMime
    };

    if (previewUrl && previewUrl.startsWith('data:')) {
      fetch(previewUrl)
        .then((r) => r.blob())
        .then((blob) => {
          state.uploadedFiles[index].blob = new File([blob], fileName, { type: resolvedMime });
          precacheImageForCanvas(index);
        });
    } else {
      precacheImageForCanvas(index);
    }

    updatePreview(index, previewUrl);
    checkCustomizationStatus();
    saveState();
  }

  /* ==========================================================================
     CROP MODAL
     ========================================================================== */
  function bindCropModal() {
    if (dom.cropConfirm) {
      dom.cropConfirm.addEventListener('click', handleCropConfirm);
    }
    if (dom.cropCancel) {
      dom.cropCancel.addEventListener('click', closeCropModal);
    }
  }

  function openCropModal(imageSource, index, originalFile) {
    if (!dom.cropModal || !dom.cropImage) return;

    state.cropTargetIndex = index;
    state.cropOriginalFile = originalFile;
    var srcMime = (originalFile && originalFile.type) || (imageSource && imageSource.type) || mimeFromFilename(originalFile && originalFile.name) || 'image/jpeg';
    state.cropSourceMime = srcMime;
    state.cropSourceName = (originalFile && originalFile.name) || '';

    if (state.cropper) {
      state.cropper.destroy();
      state.cropper = null;
    }

    dom.cropImage.onload = null;
    dom.cropImage.src = '';

    function initCropper() {
      if (typeof Cropper === 'undefined') {
        console.warn('[Vinyl] Cropper not loaded yet, retrying...');
        setTimeout(initCropper, 300);
        return;
      }
      if (!dom.cropImage.complete || dom.cropImage.naturalWidth === 0) {
        console.warn('[Vinyl] Image not ready, retrying...');
        setTimeout(initCropper, 200);
        return;
      }

      if (state.cropper) {
        state.cropper.destroy();
        state.cropper = null;
      }

      dom.cropImage.style.opacity = '1';

      state.cropper = new Cropper(dom.cropImage, {
        aspectRatio: 1,
        viewMode: 2,
        autoCrop: true,
        autoCropArea: 1,
        movable: true,
        zoomable: true,
        scalable: true,
        rotatable: true,
        responsive: true,
        background: true,
        guides: true,
        center: true,
        highlight: true,
        cropBoxMovable: true,
        cropBoxResizable: true,
        dragMode: 'move',
        minContainerWidth: 200,
        minContainerHeight: 200
      });
    }

    dom.cropImage.onload = function() {
      initCropper();
    };

    dom.cropImage.onerror = function() {
      console.error('[Vinyl] Failed to load crop image');
    };

    if (typeof imageSource === 'string') {
      dom.cropImage.src = imageSource;
    } else {
      var url = URL.createObjectURL(imageSource);
      dom.cropImage.src = url;
    }

    dom.cropModal.style.display = 'flex';

    setTimeout(function() {
      if (!state.cropper && dom.cropImage.complete && dom.cropImage.naturalWidth > 0) {
        initCropper();
      }
    }, 500);

    setTimeout(function() {
      if (!state.cropper && dom.cropImage.complete && dom.cropImage.naturalWidth > 0) {
        initCropper();
      }
    }, 1500);
  }

  function handleCropConfirm() {
    const index = state.cropTargetIndex;
    var maxBytes = getMaxBytes(index);
    var sourceMime = state.cropSourceMime || 'image/jpeg';

    if (state.cropper) {
      var cropData = state.cropper.getData();
      var origCropW = Math.round(cropData.width);
      var origCropH = Math.round(cropData.height);
      const canvas = state.cropper.getCroppedCanvas({
        width: origCropW,
        height: origCropH,
        imageSmoothingQuality: 'high'
      });

      if (canvas) {
        encodeCanvasPreservingFormat(canvas, sourceMime, maxBytes).then(function(result) {
          uploadToFilestack(result.dataUrl, index, result.width, result.height, origCropW, origCropH, result.mime);
        });
      }
    } else {
      const dataUrl = dom.cropImage.src;
      const img = new Image();
      img.onload = () => {
        var tempCanvas = document.createElement('canvas');
        tempCanvas.width = img.naturalWidth;
        tempCanvas.height = img.naturalHeight;
        tempCanvas.getContext('2d').drawImage(img, 0, 0);
        encodeCanvasPreservingFormat(tempCanvas, sourceMime, maxBytes).then(function(result) {
          uploadToFilestack(result.dataUrl, index, result.width, result.height, img.naturalWidth, img.naturalHeight, result.mime);
        });
      };
      img.src = dataUrl;
    }
  }

  function uploadToFilestack(dataUrl, index, width, height, origW, origH, mimeType) {
    const animation = dom.cropModal.querySelector('.vinyl-crop-modal__upload-animation');
    const actions = dom.cropModal.querySelector('.vinyl-crop-modal__actions');

    if (animation) animation.style.display = 'block';
    if (actions) actions.style.display = 'none';

    var resolvedMime = mimeType || 'image/jpeg';
    var ext = extFromMime(resolvedMime);
    var filename = 'vinyl_image_' + index + '.' + ext;

    fetch(dataUrl)
      .then(function(res) { return res.blob(); })
      .then(function(blob) {
        var imageBlob = new File([blob], filename, { type: resolvedMime });

        function tryFilestack() {
          if (!FILESTACK_API_KEY) return Promise.reject('no key');
          var fd = new FormData();
          fd.append('fileUpload', imageBlob, filename);
          fd.append('filename', filename);
          fd.append('mimetype', resolvedMime);
          return fetch('https://www.filestackapi.com/api/store/S3?key=' + FILESTACK_API_KEY, {
            method: 'POST', body: fd
          }).then(function(res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          }).then(function(text) {
            try {
              var data = JSON.parse(text);
              // Return raw Filestack handle URL with ?dl=true so a click in
              // Shopify Admin triggers an attachment download (Content-
              // Disposition switches from `inline` to `attachment`) instead
              // of opening the image in a new tab. Original filename is
              // preserved via the multipart `filename` field above.
              if (data.url) return data.url + '?dl=true';
              throw new Error('No URL');
            } catch(e) {
              if (text.indexOf('blocked') !== -1) throw new Error('Filestack blocked');
              throw e;
            }
          });
        }

        return tryFilestack().catch(function(err) {
          console.warn('[Vinyl] Filestack crop upload failed, using Shopify CDN:', err.message || err);
          return uploadBlobToShopifyCdn(imageBlob, filename);
        });
      })
      .then(function(result) {
        var fileUrl = (typeof result === 'string' && result.indexOf('://') !== -1) ? result : dataUrl;
        console.log('[Vinyl] Crop image ' + index + ' uploaded (' + resolvedMime + '):', fileUrl.substring(0, 80));
        finalizeCrop(index, fileUrl, dataUrl, width, height, origW, origH, resolvedMime, filename);
      })
      .catch(function() {
        finalizeCrop(index, dataUrl, dataUrl, width, height, origW, origH, resolvedMime, filename);
      });
  }

  function finalizeCrop(index, fileUrl, previewUrl, width, height, origW, origH, mimeType, fileName) {
    var resolvedMime = mimeType || 'image/jpeg';
    var resolvedName = fileName || ('vinyl_image_' + index + '.' + extFromMime(resolvedMime));
    const resolution = `${width} x ${height}px`;

    showUploadedFile(index, resolvedName, resolution, previewUrl, fileUrl, origW || width, origH || height, resolvedMime);
    updateDpiBadge(index, origW || width, origH || height);
    closeCropModal();
  }

  function updateDpiBadge(index, width, height) {
    var badge = document.querySelector('.vinyl-dpi-badge[data-index="' + index + '"]');
    if (!badge) return;

    var printSize = (index <= 2) ? 13 : 3.5;
    var dpi = parseInt(width / printSize, 10);
    var tierClass, tierLabel;

    if (dpi > 300) {
      tierClass = 'vinyl-dpi-badge--high';
      tierLabel = 'High quality';
    } else if (dpi > 150) {
      tierClass = 'vinyl-dpi-badge--good';
      tierLabel = 'Good quality';
    } else {
      tierClass = 'vinyl-dpi-badge--low';
      tierLabel = 'Low quality';
    }

    badge.className = 'vinyl-dpi-badge ' + tierClass;
    badge.textContent = tierLabel + ' Print (' + dpi + ' DPI)';
  }

  function closeCropModal() {
    if (state.cropper) {
      state.cropper.destroy();
      state.cropper = null;
    }
    if (dom.cropModal) {
      dom.cropModal.style.display = 'none';
      const animation = dom.cropModal.querySelector('.vinyl-crop-modal__upload-animation');
      const actions = dom.cropModal.querySelector('.vinyl-crop-modal__actions');
      if (animation) animation.style.display = 'none';
      if (actions) actions.style.display = '';
    }
    state.cropTargetIndex = null;
    state.cropOriginalFile = null;
    state.cropSourceMime = null;
    state.cropSourceName = null;
  }

  /* ==========================================================================
     RECORD SIZE OPTIONS
     ========================================================================== */
  function bindRecordOptions() {
    const radios = document.querySelectorAll('input[name="Record option"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', handleRecordOptionChange);
    });
  }

  function handleRecordOptionChange(e) {
    const radio = e.target;
    var previousRecord = state.selectedRecord;

    state.selectedRecord = radio.value;
    state.maxDuration = parseInt(radio.dataset.max_duration, 10) || 7;
    state.maxTracks = parseInt(radio.dataset.max_tracks, 10) || 2;
    state.recordPriceAdd = parseFloat(radio.dataset.priceAdd || radio.dataset.price_add) || 0;

    var newVariantId = radio.dataset.variant_id;
    if (newVariantId) {
      var variantInput = document.querySelector('.product-variant-id');
      if (variantInput) variantInput.value = newVariantId;
    }

    if (previousRecord && previousRecord !== radio.value) {
      state.tracks.A = [];
      state.tracks.B = [];
      state.uploadMode = '';

      ['A', 'B'].forEach(function(side) {
        renderTrackList(side);
        updateTrackTime(side);
        updateMusicTextarea(side);
      });

      var uploadModeRadios = document.querySelectorAll('input[name="Upload Mode"]');
      uploadModeRadios.forEach(function(r) { r.checked = false; });

      var sideWrappers = document.querySelectorAll('.vinyl-side-wrapper');
      sideWrappers.forEach(function(sw) { sw.classList.add('visually-hidden'); });

      var tracklistChoices = document.querySelector('.vinyl-tracklist-choices');
      if (tracklistChoices) tracklistChoices.classList.add('visually-hidden');
    }

    var hideSticker = radio.dataset.hide_step === '4';
    var step4El = document.getElementById('step4');
    var step5El = document.getElementById('step5');
    if (step4El) {
      if (hideSticker) {
        step4El.style.display = 'none';
        var skipContent = step4El.querySelector('.vinyl-skip-content');
        if (skipContent) skipContent.classList.add('active');
      } else {
        step4El.style.display = '';
        var skipContent2 = step4El.querySelector('.vinyl-skip-content');
        if (skipContent2) skipContent2.classList.remove('active');
      }
    }
    if (step5El) {
      step5El.style.display = hideSticker ? 'none' : '';
    }

    updateMaxValues();
    updatePriceDisplay();
    checkCustomizationStatus();
    saveState();

    const selectedDisplay = document.querySelector('.vinyl-record-options__selected');
    if (selectedDisplay) {
      selectedDisplay.textContent = radio.value;
      selectedDisplay.classList.remove('visually-hidden');
    }

    const heartImgA = radio.dataset.img_2;
    const heartImgB = radio.dataset.img_3;
    if (heartImgA) updatePreview(3, heartImgA);
    if (heartImgB) updatePreview(4, heartImgB);

    var is7inch = state.maxDuration <= 7;
    document.querySelectorAll('.vinyl-preview__vinyl').forEach(function(el) {
      el.classList.toggle('vinyl-preview__vinyl--sm', is7inch);
    });
    if (window.__safariVinylFix) setTimeout(fixSafariPreview, 50);

    var isColorRecord = radio.dataset.colorRecord === 'true';
    var palette = document.getElementById('recordColorPalette');
    if (palette) {
      if (isColorRecord) {
        palette.classList.add('vinyl-record-color-palette--visible');
        if (!state.recordColor) {
          state.recordColor = '#804040';
          if (recordPickr) recordPickr.setColor('#804040');
          applyVinylColor('#804040');
        }
      } else {
        palette.classList.remove('vinyl-record-color-palette--visible');
        state.recordColor = null;
        if (recordPickr) recordPickr.setColor('#804040');
        resetVinylColor();
      }
    }
  }

  /* ==========================================================================
     RECORD COLOR (12" Color Record palette)
     ========================================================================== */

  function hexToRgb(hex) {
    hex = hex.replace('#', '');
    return {
      r: parseInt(hex.substring(0, 2), 16),
      g: parseInt(hex.substring(2, 4), 16),
      b: parseInt(hex.substring(4, 6), 16)
    };
  }

  function darkenHex(hex, factor) {
    var rgb = hexToRgb(hex);
    var r = Math.round(rgb.r * factor);
    var g = Math.round(rgb.g * factor);
    var b = Math.round(rgb.b * factor);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  function applyVinylColor(hex) {
    var dark = darkenHex(hex, 0.55);
    var mid = darkenHex(hex, 0.7);
    var colorGradient = 'radial-gradient(circle, ' +
      hex + ' 0%, ' + mid + ' 45%, ' + dark + ' 100%)';
    document.querySelectorAll('.vinyl-preview__vinyl-color').forEach(function(el) {
      el.style.background = colorGradient;
    });
    document.querySelectorAll('.vinyl-preview__vinyl-img').forEach(function(el) {
      el.style.mixBlendMode = 'screen';
    });
  }

  function resetVinylColor() {
    document.querySelectorAll('.vinyl-preview__vinyl-color').forEach(function(el) {
      el.style.background = '';
    });
    document.querySelectorAll('.vinyl-preview__vinyl-img').forEach(function(el) {
      el.style.mixBlendMode = '';
    });
  }

  var _flashTimers = {};

  function flashPickrButton(btn, label) {
    if (!btn) return;
    var btnId = btn.getAttribute('data-flash-id');
    if (!btnId) {
      btnId = 'flash_' + Math.random().toString(36).substr(2, 6);
      btn.setAttribute('data-flash-id', btnId);
    }
    if (_flashTimers[btnId]) clearTimeout(_flashTimers[btnId]);
    var orig = btn.classList.contains('pcr-save') ? 'Save' : 'Clear';
    var cls = btn.classList.contains('pcr-save') ? 'pcr-save--done' : 'pcr-clear--done';
    btn.value = label;
    btn.classList.add(cls);
    _flashTimers[btnId] = setTimeout(function() {
      btn.value = orig;
      btn.classList.remove(cls);
      delete _flashTimers[btnId];
    }, 1500);
  }

  function getPickrBtn(pickrInstance, type) {
    if (!pickrInstance || !pickrInstance.getRoot) return null;
    var root = pickrInstance.getRoot();
    if (root.interaction && root.interaction[type]) return root.interaction[type];
    var app = root.app || root.root;
    return app ? app.querySelector('.pcr-' + type) : null;
  }

  function resetPickrSaveBtn(pickrInstance) {
    var btn = getPickrBtn(pickrInstance, 'save');
    if (!btn) return;
    var btnId = btn.getAttribute('data-flash-id');
    if (btnId && _flashTimers[btnId]) {
      clearTimeout(_flashTimers[btnId]);
      delete _flashTimers[btnId];
    }
    btn.value = 'Save';
    btn.classList.remove('pcr-save--done');
  }

  function updateColorIndicator(containerId, hex) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var indicator = container.querySelector('.vinyl-color-indicator');
    if (!indicator) {
      indicator = document.createElement('span');
      indicator.className = 'vinyl-color-indicator';
      indicator.innerHTML = '<span class="vinyl-color-indicator__swatch"></span><span class="vinyl-color-indicator__hex"></span>';
      var label = container.querySelector('.vinyl-field-label');
      if (label) {
        label.appendChild(indicator);
      } else {
        container.insertBefore(indicator, container.firstChild);
      }
    }
    var swatch = indicator.querySelector('.vinyl-color-indicator__swatch');
    var hexLabel = indicator.querySelector('.vinyl-color-indicator__hex');
    if (swatch) swatch.style.backgroundColor = hex;
    if (hexLabel) hexLabel.textContent = hex;
  }

  function updateRecordColorUI(color) {
    var preview = document.getElementById('recordColorPreview');
    var hexInput = document.getElementById('recordColorHex');
    if (preview) preview.style.background = color;
    if (hexInput) hexInput.value = color;
  }

  var recordPickr = null;

  function bindRecordColorPalette() {
    var mountEl = document.getElementById('pickrMountRecordColor');
    if (!mountEl || mountEl.dataset.pickrReady) return;

    function tryInit() {
      if (typeof Pickr === 'undefined') { setTimeout(tryInit, 200); return; }

      var savedColor = state.recordColor || '#804040';
      recordPickr = Pickr.create({
        el: mountEl,
        theme: 'nano',
        useAsButton: true,
        inline: true,
        showAlways: true,
        default: savedColor,
        defaultRepresentation: 'HEXA',
        position: 'bottom-start',
        components: {
          preview: true,
          opacity: false,
          hue: true,
          interaction: {
            hex: true,
            input: true,
            save: true,
            clear: true,
            cancel: false
          }
        }
      });

      var _clearingRecord = false;

      recordPickr.on('change', function(color) {
        if (!color) return;
        var hex = color.toHEXA().toString().substring(0, 7);
        state.recordColor = hex;
        applyVinylColor(hex);
        resetPickrSaveBtn(recordPickr);
        recordPickr.applyColor(false);
      });

      recordPickr.on('save', function(color) {
        if (_clearingRecord) return;
        if (!color) return;
        var hex = color.toHEXA().toString().substring(0, 7);
        state.recordColor = hex;
        applyVinylColor(hex);
        saveState();
        flashPickrButton(getPickrBtn(recordPickr, 'save'), 'Saved!');
        updateColorIndicator('recordColorPalette', hex);
      });

      recordPickr.on('clear', function() {
        _clearingRecord = true;
        state.recordColor = '#000000';
        applyVinylColor('#000000');
        saveState();
        recordPickr.setColor('#000000');
        flashPickrButton(getPickrBtn(recordPickr, 'clear'), 'Cleared!');
        updateColorIndicator('recordColorPalette', '#000000');
        setTimeout(function() { _clearingRecord = false; }, 50);
      });

      mountEl.dataset.pickrReady = '1';
    }
    tryInit();
  }

  function updateMaxValues() {
    document.querySelectorAll('.max_songs').forEach((el) => {
      el.textContent = state.maxTracks;
    });
    document.querySelectorAll('.total_value').forEach((el) => {
      el.textContent = state.maxDuration;
    });
  }

  /* ==========================================================================
     UPLOAD MODE (Research vs Own Files)
     ========================================================================== */
  function bindUploadMode() {
    const radios = document.querySelectorAll('input[name="Upload Mode"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', handleUploadModeChange);
    });
  }

  function handleUploadModeChange(e) {
    state.uploadMode = e.target.value;

    // Clear all tracks from both sides when switching mode
    state.tracks.A = [];
    state.tracks.B = [];
    ['A', 'B'].forEach(function(side) {
      renderTrackList(side);
      updateTrackTime(side);
      updateMusicTextarea(side);
    });

    const sideWrappers = document.querySelectorAll('.vinyl-side-wrapper');
    const tracklistChoices = document.querySelector('.vinyl-tracklist-choices');

    sideWrappers.forEach((sw) => sw.classList.remove('visually-hidden'));
    if (tracklistChoices) tracklistChoices.classList.remove('visually-hidden');

    sideWrappers.forEach((sw) => {
      const uploadLabel = sw.querySelector('.vinyl-music-uploader__upload');
      const manualLabel = sw.querySelector('.vinyl-music-uploader__manual');

      if (state.uploadMode === 'Own Files') {
        if (uploadLabel) uploadLabel.style.display = '';
        if (manualLabel) manualLabel.style.display = 'none';
      } else {
        if (uploadLabel) uploadLabel.style.display = 'none';
        if (manualLabel) manualLabel.style.display = '';
      }
    });

    saveState();
    checkCustomizationStatus();
  }

  /* ==========================================================================
     MUSIC MANAGEMENT
     ========================================================================== */
  function openMusicUploadModal(uploader, sideIndex) {
    const side = sideIndex === 5 ? 'A' : 'B';

    if (state.tracks[side].length >= state.maxTracks) {
      alert(`Maximum ${state.maxTracks} tracks per side.`);
      return;
    }

    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'audio/*';
    fileInput.style.display = 'none';

    fileInput.addEventListener('change', (e) => {
      if (e.target.files.length > 0) {
        handleMusicFile(e.target.files[0], side, uploader);
      }
      fileInput.remove();
    });

    document.body.appendChild(fileInput);
    fileInput.click();
  }

  function handleMusicFile(file, side, uploaderEl) {
    const loadingEl = uploaderEl.querySelector('.vinyl-music-uploader__loading');
    const defaultEl = uploaderEl.querySelector('.vinyl-music-uploader__default');
    const loaderBar = uploaderEl.querySelector('.vinyl-upload-loader__bar');

    if (loadingEl) loadingEl.style.display = '';
    if (defaultEl) defaultEl.style.display = 'none';
    if (loaderBar) {
      loaderBar.style.maxWidth = '0';
      loaderBar.classList.add('fallback');
      requestAnimationFrame(() => {
        loaderBar.style.maxWidth = '85%';
      });
    }

    const audio = new Audio();
    const objectUrl = URL.createObjectURL(file);
    audio.src = objectUrl;

    audio.addEventListener('loadedmetadata', () => {
      const duration = audio.duration;
      URL.revokeObjectURL(objectUrl);

      if (FILESTACK_API_KEY) {
        uploadMusicToFilestack(file, side, duration, uploaderEl, loaderBar, loadingEl, defaultEl);
      } else {
        uploadMusicToShopifyCdn(file, side, duration, uploaderEl, loaderBar, loadingEl, defaultEl);
      }
    });

    audio.addEventListener('error', () => {
      URL.revokeObjectURL(objectUrl);
      addTrack(side, file.name, '??:??', 0, '');
      resetMusicUploader(uploaderEl, loaderBar, loadingEl, defaultEl);
    });
  }

  function uploadMusicToShopifyCdn(file, side, duration, uploaderEl, loaderBar, loadingEl, defaultEl) {
    _audioUploadQueue = _audioUploadQueue.then(function() {
      return new Promise(function(resolve) {
        var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var variantId = variantInput ? variantInput.value : (config.variantId || '');

        if (!variantId) {
          console.warn('[Vinyl] No variant ID for audio upload');
          addTrack(side, file.name, formatDuration(duration), duration, '', file);
          resetMusicUploader(uploaderEl, loaderBar, loadingEl, defaultEl);
          resolve();
          return;
        }

        var propKey = '_aud_' + side + '_' + Date.now();
        var frameName = 'vinyl_audio_frame_' + Date.now();

        var iframe = document.createElement('iframe');
        iframe.name = frameName;
        iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none';
        document.body.appendChild(iframe);

        var form = document.createElement('form');
        form.method = 'POST';
        form.action = '/cart/add';
        form.enctype = 'multipart/form-data';
        form.target = frameName;
        form.style.display = 'none';

        var inp = function(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; form.appendChild(i); };
        inp('id', variantId);
        inp('quantity', '1');

        var fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.name = 'properties[' + propKey + ']';
        fileInput.style.display = 'none';
        try {
          var dt = new DataTransfer();
          dt.items.add(file);
          fileInput.files = dt.files;
        } catch (e) {
          console.warn('[Vinyl] DataTransfer not supported, using fallback');
          addTrack(side, file.name, formatDuration(duration), duration, '', file);
          resetMusicUploader(uploaderEl, loaderBar, loadingEl, defaultEl);
          resolve();
          return;
        }
        form.appendChild(fileInput);
        document.body.appendChild(form);

        console.log('[Vinyl] Uploading audio via native form:', file.name, '(' + (file.size / 1024).toFixed(0) + 'KB)');

        var attempts = 0;
        var maxAttempts = 40;

        function poll() {
          attempts++;
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var cdnUrl = '';
              var itemKey = '';

              for (var i = 0; i < cart.items.length; i++) {
                var p = cart.items[i].properties;
                if (p && p[propKey] !== undefined) {
                  itemKey = cart.items[i].key;
                  var val = typeof p[propKey] === 'string' ? p[propKey] : '';
                  if (val.indexOf('cdn.shopify.com') !== -1) {
                    cdnUrl = val;
                  }
                  break;
                }
              }

              if (!cdnUrl && attempts < maxAttempts) {
                if (attempts % 5 === 0) console.log('[Vinyl] Polling cart for CDN URL... attempt', attempts);
                setTimeout(poll, 500);
                return;
              }

              console.log('[Vinyl] Audio CDN result:', cdnUrl ? cdnUrl : 'FAILED after ' + attempts + ' attempts');

              var cleanup = itemKey
                ? fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: itemKey, quantity: 0 }) }).catch(function() {})
                : Promise.resolve();

              cleanup.then(function() {
                addTrack(side, file.name, formatDuration(duration), duration, cdnUrl || '', cdnUrl ? null : file);
                resetMusicUploader(uploaderEl, loaderBar, loadingEl, defaultEl);
                try { form.remove(); iframe.remove(); } catch(e) {}
                resolve();
              });
            })
            .catch(function() {
              if (attempts < maxAttempts) { setTimeout(poll, 500); }
              else {
                addTrack(side, file.name, formatDuration(duration), duration, '', file);
                resetMusicUploader(uploaderEl, loaderBar, loadingEl, defaultEl);
                try { form.remove(); iframe.remove(); } catch(e) {}
                resolve();
              }
            });
        }

        form.submit();
        setTimeout(poll, 2000);
      });
    });
  }

  function uploadMusicToFilestack(file, side, duration, uploaderEl, loaderBar, loadingEl, defaultEl) {
    const formData = new FormData();
    formData.append('fileUpload', file, file.name);
    console.log('[Vinyl] Uploading audio to Filestack:', file.name, '(' + (file.size / 1024).toFixed(0) + 'KB)');

    fetch('https://www.filestackapi.com/api/store/S3?key=' + FILESTACK_API_KEY, {
      method: 'POST',
      body: formData
    })
      .then(function(res) {
        if (!res.ok) throw new Error('Filestack HTTP ' + res.status);
        return res.text();
      })
      .then(function(text) {
        try {
          var data = JSON.parse(text);
          if (data.url) {
            var url = data.url + '?dl=true';
            console.log('[Vinyl] Filestack upload OK:', url);
            addTrack(side, file.name, formatDuration(duration), duration, url);
            resetMusicUploader(uploaderEl, loaderBar, loadingEl, defaultEl);
            return;
          }
          throw new Error('No URL in response');
        } catch (e) {
          if (text.indexOf('blocked') !== -1) throw new Error('Filestack blocked');
          throw e;
        }
      })
      .catch(function(err) {
        console.warn('[Vinyl] Filestack audio failed, falling back to Shopify CDN:', err.message || err);
        uploadMusicToShopifyCdn(file, side, duration, uploaderEl, loaderBar, loadingEl, defaultEl);
      });
  }

  function resetMusicUploader(uploaderEl, loaderBar, loadingEl, defaultEl) {
    if (loaderBar) {
      loaderBar.classList.add('complete');
      setTimeout(() => {
        loaderBar.classList.remove('complete', 'fallback');
        loaderBar.style.maxWidth = '0';
      }, 500);
    }
    if (loadingEl) loadingEl.style.display = 'none';
    if (defaultEl) defaultEl.style.display = '';
  }

  function openManualSongEntry(uploader, sideIndex) {
    const side = sideIndex === 5 ? 'A' : 'B';
    const trackNum = state.tracks[side].length + 1;

    if (state.tracks[side].length >= state.maxTracks) {
      alert(`Maximum ${state.maxTracks} tracks per side.`);
      return;
    }

    const wrapper = uploader.closest('.vinyl-side-wrapper');
    const existingSearch = wrapper.querySelector('.vinyl-song-search');
    if (existingSearch) {
      existingSearch.remove();
      return;
    }

    const searchEl = document.createElement('div');
    searchEl.className = 'vinyl-song-search';
    searchEl.innerHTML = `
      <div class="vinyl-song-search__header">
        <button type="button" class="vinyl-song-search__delete" aria-label="Cancel">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M3 6H5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M8 6V4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V6M19 6V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
        <span class="vinyl-song-search__label"><b>${trackNum}.</b> Song Name:</span>
        <a href="#" class="vinyl-song-search__manual-link">Can't find song? Click Here</a>
      </div>
      <div class="vinyl-song-search__input-wrap">
        <input type="text" class="vinyl-song-search__input" placeholder="Search for a song..." autocomplete="off">
      </div>
      <div class="vinyl-song-search__results" style="display:none;"></div>
    `;

    const musicUploader = wrapper.querySelector('.vinyl-music-uploader');
    wrapper.insertBefore(searchEl, musicUploader);

    const input = searchEl.querySelector('.vinyl-song-search__input');
    const resultsEl = searchEl.querySelector('.vinyl-song-search__results');
    let debounceTimer = null;

    input.focus();

    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const query = input.value.trim();
      if (query.length < 2) {
        resultsEl.style.display = 'none';
        resultsEl.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(() => {
        searchITunes(query, resultsEl, side, searchEl);
      }, 350);
    });

    searchEl.querySelector('.vinyl-song-search__delete').addEventListener('click', () => {
      searchEl.remove();
    });

    searchEl.querySelector('.vinyl-song-search__manual-link').addEventListener('click', (e) => {
      e.preventDefault();
      searchEl.remove();
      openManualTextEntry(uploader, sideIndex);
    });
  }

  function searchITunes(query, resultsEl, side, searchEl) {
    var callbackName = '_vinylDeezer_' + Date.now() + '_' + Math.floor(Math.random() * 10000);
    var timeoutId = setTimeout(function() {
      delete window[callbackName];
      if (script.parentNode) script.parentNode.removeChild(script);
      resultsEl.innerHTML = '<div class="vinyl-song-result vinyl-song-result--empty">Search error, try again</div>';
      resultsEl.style.display = '';
    }, 8000);

    window[callbackName] = function(data) {
      clearTimeout(timeoutId);
      delete window[callbackName];
      if (script.parentNode) script.parentNode.removeChild(script);

      resultsEl.innerHTML = '';
      var tracks = (data && data.data) ? data.data : [];
      if (tracks.length === 0) {
        resultsEl.innerHTML = '<div class="vinyl-song-result vinyl-song-result--empty">No songs found</div>';
        resultsEl.style.display = '';
        return;
      }

      tracks.forEach(function(song) {
        var durationSec = song.duration || 0;
        var durationStr = formatDuration(durationSec);
        var artwork = (song.album && song.album.cover_medium) ? song.album.cover_medium : '';
        var trackName = song.title || 'Unknown';
        var artistName = (song.artist && song.artist.name) ? song.artist.name : 'Unknown';

        var item = document.createElement('div');
        item.className = 'vinyl-song-result';
        item.innerHTML =
          '<img class="vinyl-song-result__art" src="' + artwork + '" alt="" loading="lazy">' +
          '<div class="vinyl-song-result__info">' +
            '<div class="vinyl-song-result__name">' + escapeHtml(trackName) + '</div>' +
            '<div class="vinyl-song-result__artist">' + escapeHtml(artistName) + '</div>' +
          '</div>' +
          '<span class="vinyl-song-result__duration">' + durationStr + '</span>';

        item.addEventListener('click', function() {
          var displayName = trackName + ' \u2014 ' + artistName;
          addTrack(side, displayName, durationStr, durationSec, trackName);
          searchEl.remove();
        });

        resultsEl.appendChild(item);
      });

      resultsEl.style.display = '';
    };

    var script = document.createElement('script');
    script.src = 'https://api.deezer.com/search?q=' + encodeURIComponent(query) + '&limit=5&output=jsonp&callback=' + callbackName;
    script.onerror = function() {
      clearTimeout(timeoutId);
      delete window[callbackName];
      if (script.parentNode) script.parentNode.removeChild(script);
      resultsEl.innerHTML = '<div class="vinyl-song-result vinyl-song-result--empty">Search error, try again</div>';
      resultsEl.style.display = '';
    };
    document.head.appendChild(script);
  }

  function openManualTextEntry(uploader, sideIndex) {
    const side = sideIndex === 5 ? 'A' : 'B';

    if (state.tracks[side].length >= state.maxTracks) {
      alert(`Maximum ${state.maxTracks} tracks per side.`);
      return;
    }

    const wrapper = uploader.closest('.vinyl-side-wrapper');
    const form = document.createElement('div');
    form.className = 'vinyl-manual-song';
    form.innerHTML = `
      <div class="vinyl-manual-song__field">
        <label>Song Title / Link</label>
        <input type="text" class="vinyl-manual-song__title" placeholder="Enter song title or streaming link">
      </div>
      <div class="vinyl-manual-song__field">
        <label>Artist (optional)</label>
        <input type="text" class="vinyl-manual-song__artist" placeholder="Enter artist name">
      </div>
      <div class="vinyl-manual-song__actions">
        <button type="button" class="vinyl-btn vinyl-btn--primary" style="padding:8px 16px;font-size:13px;" data-action="add">Add Song</button>
        <button type="button" class="vinyl-btn vinyl-btn--outline" style="padding:8px 16px;font-size:13px;" data-action="cancel">Cancel</button>
      </div>
    `;

    const musicUploader = wrapper.querySelector('.vinyl-music-uploader');
    wrapper.insertBefore(form, musicUploader);

    form.querySelector('[data-action="add"]').addEventListener('click', () => {
      const title = form.querySelector('.vinyl-manual-song__title').value.trim();
      const artist = form.querySelector('.vinyl-manual-song__artist').value.trim();
      if (title) {
        const displayName = artist ? `${title} — ${artist}` : title;
        addTrack(side, displayName, 'Manual', 0, title);
        form.remove();
      }
    });

    form.querySelector('[data-action="cancel"]').addEventListener('click', () => {
      form.remove();
    });
  }

  function addTrack(side, name, durationStr, durationSec, fileUrl, file) {
    const currentTotal = state.tracks[side].reduce((sum, t) => sum + (t.durationSec || 0), 0);
    const maxSec = state.maxDuration * 60;

    if (durationSec > 0 && currentTotal + durationSec > maxSec) {
      const remaining = maxSec - currentTotal;
      if (remaining <= 0) {
        alert(`Side ${side} is full. Maximum ${state.maxDuration} minutes per side. Remove a track to add a new one.`);
        return false;
      }
      const ok = confirm(
        `Adding "${name}" (${durationStr}) will exceed the ${state.maxDuration}-minute limit for Side ${side}.\n` +
        `Current total: ${formatDuration(currentTotal)}, remaining: ${formatDuration(remaining)}.\n\n` +
        `Add anyway?`
      );
      if (!ok) return false;
    }

    if (state.tracks[side].length >= state.maxTracks) {
      alert(`Maximum ${state.maxTracks} tracks per side.`);
      return false;
    }

    state.tracks[side].push({
      name,
      durationStr,
      durationSec,
      fileUrl,
      file: file || null
    });

    renderTrackList(side);
    updateTrackTime(side);
    updateMusicTextarea(side);
    checkCustomizationStatus();
    saveState();
    return true;
  }

  function removeTrack(side, trackIndex) {
    state.tracks[side].splice(trackIndex, 1);
    renderTrackList(side);
    updateTrackTime(side);
    updateMusicTextarea(side);
    checkCustomizationStatus();
    saveState();
  }

  function renderTrackList(side) {
    const sideIndex = side === 'A' ? 5 : 6;
    const wrapper = document.querySelector(`.vinyl-side-wrapper[data-index="${sideIndex}"]`);
    if (!wrapper) return;

    const listEl = wrapper.querySelector('.vinyl-track-list');
    const countEl = wrapper.querySelector('.count_value');

    if (!listEl) return;

    listEl.innerHTML = '';

    state.tracks[side].forEach((track, i) => {
      const item = document.createElement('div');
      item.className = 'vinyl-track-item';
      item.innerHTML = `
        <span class="vinyl-track-item__number">${i + 1}</span>
        <div class="vinyl-track-item__info">
          <div class="vinyl-track-item__name">${escapeHtml(track.name)}</div>
          <div class="vinyl-track-item__details">
            <span>${track.durationStr}</span>
          </div>
        </div>
        <span class="vinyl-track-item__duration">${track.durationStr}</span>
        <button type="button" class="vinyl-track-item__delete" data-side="${side}" data-index="${i}" aria-label="Remove track">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      `;
      listEl.appendChild(item);

      item.querySelector('.vinyl-track-item__delete').addEventListener('click', () => {
        removeTrack(side, i);
      });
    });

    if (countEl) countEl.textContent = state.tracks[side].length;
  }

  function updateTrackTime(side) {
    const sideIndex = side === 'A' ? 5 : 6;
    const wrapper = document.querySelector(`.vinyl-side-wrapper[data-index="${sideIndex}"]`);
    if (!wrapper) return;

    const totalSec = state.tracks[side].reduce((sum, t) => sum + (t.durationSec || 0), 0);
    const lengthEl = wrapper.querySelector('.length_value');
    if (lengthEl) {
      lengthEl.innerHTML = `<b>${formatDuration(totalSec)}</b>`;
    }

    const maxMins = state.maxDuration;
    const lengthError = wrapper.querySelector('.vinyl-error--side-length');
    const countError = wrapper.querySelector('.vinyl-error--side-count');

    if (lengthError) {
      if (totalSec > maxMins * 60) {
        lengthError.classList.remove('visually-hidden');
      } else {
        lengthError.classList.add('visually-hidden');
      }
    }

    if (countError) {
      if (state.tracks[side].length > state.maxTracks) {
        countError.classList.remove('visually-hidden');
      } else {
        countError.classList.add('visually-hidden');
      }
    }
  }

  function updateMusicTextarea(side) {
    const sideIndex = side === 'A' ? 5 : 6;
    const textarea = document.querySelector(`textarea[data-index="${sideIndex}"]`);
    if (!textarea) return;

    const data = state.tracks[side].map((t) => ({
      name: t.name,
      duration: t.durationStr,
      url: t.fileUrl
    }));

    textarea.value = JSON.stringify(data);
  }

  /* ==========================================================================
     ADDON OPTIONS
     ========================================================================== */
  function bindAddons() {
    const checkboxes = document.querySelectorAll('.vinyl-addon input[type="checkbox"]');
    checkboxes.forEach((cb) => {
      cb.addEventListener('change', handleAddonChange);
    });
    refreshAddonPriceLabels();
  }

  function refreshAddonPriceLabels() {
    updateAddonLabels();
    if (!(_isShopifyPayments && _isMultiCurrency)) {
      triggerCurrencyConverter();
    }
  }

  function convertRecordLabels() {
    if (!(_isShopifyPayments && _isMultiCurrency)) return;
    var rate = getCurrencyRate();
    document.querySelectorAll('input[name="Record option"]').forEach(function(radio) {
      var priceAdd = parseFloat(radio.dataset.price_add || radio.dataset.priceAdd) || 0;
      if (priceAdd <= 0) return;
      var label = radio.closest('label');
      if (!label) return;
      var moneySpan = label.querySelector('span.money');
      if (moneySpan) {
        var centsLocal = Math.round(priceAdd * 100 * rate);
        moneySpan.innerHTML = formatMoneyTheme(centsLocal);
      }
    });
  }

  function handleAddonChange() {
    let total = 0;
    const checkboxes = document.querySelectorAll('.vinyl-addon input[type="checkbox"]:checked');
    checkboxes.forEach((cb) => {
      total += (parseFloat(cb.dataset.value) || 0);
    });
    state.addonsTotal = total;

    const priorityCb = document.querySelector('.vinyl-addon input[data-is-priority="true"]:checked');
    if (dom.shippingDays) {
      dom.shippingDays.textContent = priorityCb ? config.priorityDays : config.processingDays;
    }

    updatePriceDisplay();
    checkCustomizationStatus();
  }

  /* ==========================================================================
     QUANTITY
     ========================================================================== */
  function bindQuantity() {
    if (dom.quantityMinus) {
      dom.quantityMinus.addEventListener('click', () => {
        const current = parseInt(dom.quantityInput.value, 10) || 1;
        if (current > 1) {
          dom.quantityInput.value = current - 1;
          state.quantity = current - 1;
          updatePriceDisplay();
        }
      });
    }

    if (dom.quantityPlus) {
      dom.quantityPlus.addEventListener('click', () => {
        const current = parseInt(dom.quantityInput.value, 10) || 1;
        dom.quantityInput.value = current + 1;
        state.quantity = current + 1;
        updatePriceDisplay();
      });
    }

    if (dom.quantityInput) {
      dom.quantityInput.addEventListener('change', () => {
        let val = parseInt(dom.quantityInput.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        dom.quantityInput.value = val;
        state.quantity = val;
        updatePriceDisplay();
      });
    }
  }

  /* ==========================================================================
     DYNAMIC PRICING
     ========================================================================== */
  function getCurrencyRate() {
    try { return parseFloat(Shopify.currency.rate) || 1; } catch(e) { return 1; }
  }

  function formatMoneyTheme(cents) {
    var fmt = config.moneyFormat || ('$' + '{{amount}}');
    var absVal = Math.abs(cents);
    var dollars = (absVal / 100).toFixed(2);
    var formatted = dollars.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    var result = fmt.replace(/\{\{\s*amount\s*\}\}/, formatted)
                    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(absVal / 100).toString())
                    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dollars.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
                    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(absVal / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'));
    return cents < 0 ? '-' + result : result;
  }

  function updatePriceDisplay() {
    var rate = getCurrencyRate();
    var addonsCentsUSD = Math.round(state.addonsTotal * 100);
    var recordAddCentsUSD = Math.round(state.recordPriceAdd * 100);

    var addonsCents, recordAddCents, baseCents;

    if (_isShopifyPayments && _isMultiCurrency) {
      baseCents = state.basePrice;
      addonsCents = Math.round(addonsCentsUSD * rate);
      recordAddCents = Math.round(recordAddCentsUSD * rate);
    } else {
      baseCents = state.basePrice;
      addonsCents = addonsCentsUSD;
      recordAddCents = recordAddCentsUSD;
    }

    var totalPerItem = baseCents + addonsCents + recordAddCents;

    var discount = 0;
    if (state.quantity >= 6) discount = 0.15;
    else if (state.quantity >= 3) discount = 0.10;

    var discountedPerItem = Math.round(totalPerItem * (1 - discount));
    var totalPrice = discountedPerItem * state.quantity;
    var baseCompareCents = state.discountRatio > 0
      ? Math.round(baseCents / (1 - state.discountRatio))
      : 0;
    var compareTotalPerItem = baseCompareCents > 0
      ? baseCompareCents + addonsCents + recordAddCents
      : 0;

    var savings = compareTotalPerItem > discountedPerItem
      ? compareTotalPerItem - discountedPerItem
      : 0;

    var priceEl = document.querySelector('.vinyl-price__current .money');
    var compareWrapper = document.querySelector('.vinyl-price__compare');
    var compareEl = compareWrapper ? compareWrapper.querySelector('.money') : null;
    var savingsAmountEl = document.querySelector('.vinyl-savings__amount .money');
    var savingsTotalEl = document.querySelector('.vinyl-savings__total .money') || document.querySelector('.vinyl-savings__total');
    var installEl = document.querySelector('.vinyl-installment-amount .money') || document.querySelector('.vinyl-installment-amount');
    var discountPctEl = document.querySelector('.vinyl-discount-percent');
    var badgeEl = document.querySelector('.vinyl-price__badge');

    var useThemeFormat = (_isShopifyPayments && _isMultiCurrency);
    var fmtFn = useThemeFormat ? formatMoneyTheme : formatMoney;

    if (priceEl) {
      priceEl.innerHTML = fmtFn(discountedPerItem);
      if (!useThemeFormat) priceEl.dataset.basecut4s = discountedPerItem;
    }

    if (compareWrapper) {
      if (savings > 0) {
        if (compareEl) {
          compareEl.innerHTML = fmtFn(compareTotalPerItem);
          if (!useThemeFormat) compareEl.dataset.basecut4s = compareTotalPerItem;
        }
        compareWrapper.classList.remove('visually-hidden');
      } else {
        compareWrapper.classList.add('visually-hidden');
      }
    }

    if (savingsAmountEl) {
      savingsAmountEl.innerHTML = fmtFn(savings);
      if (!useThemeFormat) savingsAmountEl.dataset.basecut4s = savings;
    }

    if (savingsTotalEl) {
      savingsTotalEl.innerHTML = fmtFn(totalPrice);
      if (!useThemeFormat) savingsTotalEl.dataset.basecut4s = totalPrice;
    }

    if (installEl) {
      var installCents = Math.round(discountedPerItem / 4);
      installEl.innerHTML = fmtFn(installCents);
      if (!useThemeFormat) installEl.dataset.basecut4s = installCents;
    }

    if (badgeEl) {
      if (savings > 0 && compareTotalPerItem > 0) {
        var pct = Math.round(savings / compareTotalPerItem * 100);
        if (discountPctEl) discountPctEl.textContent = pct + '%';
        badgeEl.classList.remove('visually-hidden');
      } else {
        badgeEl.classList.add('visually-hidden');
      }
    }

    updateAddonLabels();

    if (!useThemeFormat) {
      triggerCurrencyConverter();
    }
  }

  function updateAddonLabels() {
    var useThemeFormat = (_isShopifyPayments && _isMultiCurrency);
    var rate = getCurrencyRate();
    var activeCurr = 'USD';
    try { activeCurr = Shopify.currency.active || 'USD'; } catch(e) {}

    document.querySelectorAll('.vinyl-addon__price span.money').forEach(function(el) {
      var priceUSD = parseFloat(el.getAttribute('data-addon-price')) || 0;
      if (useThemeFormat) {
        var centsLocal = Math.round(priceUSD * 100 * rate);
        el.innerHTML = formatMoneyTheme(centsLocal);
      } else if (activeCurr !== 'USD' && rate !== 1) {
        var centsLocal = Math.round(priceUSD * 100 * rate);
        var converted = (centsLocal / 100).toFixed(2);
        el.textContent = (config.currencySymbol || '$') + converted;
        delete el.dataset.basecut4s;
      } else {
        el.textContent = '$' + priceUSD.toFixed(2);
        el.dataset.basecut4s = Math.round(priceUSD * 100);
      }
    });
  }

  function triggerCurrencyConverter() {
    try {
      window._vinylCurrencyUpdating = true;
      if (typeof jQuery_T4NT !== 'undefined') {
        jQuery_T4NT('body').trigger('currency:update');
      } else if (typeof jQuery !== 'undefined') {
        jQuery('body').trigger('currency:update');
      } else {
        document.body.dispatchEvent(new CustomEvent('currency:update'));
      }
      setTimeout(function() { window._vinylCurrencyUpdating = false; }, 0);
    } catch(e) {
      window._vinylCurrencyUpdating = false;
    }
  }

  /* ==========================================================================
     CUSTOMIZATION STATUS CHECK
     ========================================================================== */
  function restoreTrackListUI() {
    ['A', 'B'].forEach(function(side) {
      if (state.tracks[side] && state.tracks[side].length) {
        renderTrackList(side);
        updateTrackTime(side);
        updateMusicTextarea(side);
      }
    });
  }

  function checkCustomizationStatus() {
    const hasFrontCover = !!state.uploadedFiles[1];
    const hasBackCover = !!state.uploadedFiles[2];
    const hasRecord = !!state.selectedRecord;

    const hasStickers = !!state.uploadedFiles[3] && !!state.uploadedFiles[4];

    const hasUploadMode = !!state.uploadMode;
    const hasSideA = state.tracks.A.length > 0;

    const maxSec = state.maxDuration * 60;
    const sideATotalSec = state.tracks.A.reduce((sum, t) => sum + (t.durationSec || 0), 0);
    const sideBTotalSec = state.tracks.B.reduce((sum, t) => sum + (t.durationSec || 0), 0);
    const durationOk = sideATotalSec <= maxSec && sideBTotalSec <= maxSec;

    const isComplete = hasFrontCover && hasBackCover && hasStickers && hasRecord && hasUploadMode && hasSideA && durationOk;

    state.customizationComplete = isComplete;

    if (dom.submitBtn) {
      dom.submitBtn.disabled = !isComplete;
      dom.submitBtn.classList.toggle('vinyl-btn--customization', !isComplete);
    }

    if (dom.shopPayBtn) {
      dom.shopPayBtn.disabled = !isComplete;
      dom.shopPayBtn.classList.toggle('vinyl-btn--customization', !isComplete);
    }

    updateStepCheckmarks();
    saveState();
  }

  function updateStepCheckmarks() {
    var step1El = document.getElementById('step1');
    var step2El = document.getElementById('step2');
    var step3El = document.getElementById('step3');
    var step4El = document.getElementById('step4');
    var step5El = document.getElementById('step5');
    var step6El = document.getElementById('step6');
    var step7El = document.getElementById('step7');

    var step1Done = state.step1Visited && !!state.selectedRecord;
    var step2Done = !!state.uploadedFiles[1] && !!state.uploadedFiles[2];
    var step3Done = !!(state.coverText.A.text || state.coverText.A2.text || state.coverText.A3.text || state.coverText.B.text || state.coverText.B2.text || state.coverText.B3.text || state.coverText.B4.text);
    var step4Done = !!state.uploadedFiles[3] && !!state.uploadedFiles[4];
    var step5Done = !!(state.stickerText.A.text || state.stickerText.B.text);
    var step6Done = state.tracks.A.length > 0;

    var maxSec = state.maxDuration * 60;
    var sideATotalSec = state.tracks.A.reduce(function(sum, t) { return sum + (t.durationSec || 0); }, 0);
    var sideBTotalSec = state.tracks.B.reduce(function(sum, t) { return sum + (t.durationSec || 0); }, 0);
    var step6CountExceeded = state.tracks.A.length > state.maxTracks || state.tracks.B.length > state.maxTracks;
    var step6DurationExceeded = step6Done && (sideATotalSec > maxSec || sideBTotalSec > maxSec || step6CountExceeded);

    if (step1El) step1El.classList.toggle('vinyl-step--checked', step1Done);
    if (step2El) step2El.classList.toggle('vinyl-step--checked', step2Done);
    if (step3El) step3El.classList.toggle('vinyl-step--checked', step3Done);
    if (step4El) step4El.classList.toggle('vinyl-step--checked', step4Done);
    if (step5El) step5El.classList.toggle('vinyl-step--checked', step5Done);
    if (step6El) {
      step6El.classList.toggle('vinyl-step--error', step6DurationExceeded);
      step6El.classList.toggle('vinyl-step--checked', step6Done && !step6DurationExceeded);
    }

    var step7Done = !!document.querySelector('.vinyl-addon input[type="checkbox"]:checked');
    if (step7El) step7El.classList.toggle('vinyl-step--checked', step7Done);

    updateThumbCheck('1', !!state.uploadedFiles[1]);
    updateThumbCheck('2', !!state.uploadedFiles[2]);
    updateThumbCheck('3', !!state.uploadedFiles[3]);
    updateThumbCheck('4', !!state.uploadedFiles[4]);

    var allThumb = document.querySelector('.vinyl-preview__thumb[data-upload-index="0"]');
    if (allThumb) {
      var allDone = step2Done && step4Done;
      var check = allThumb.querySelector('.vinyl-preview__thumb-check');
      if (check) check.style.display = allDone ? '' : 'none';
    }
  }

  function updateThumbCheck(uploadIndex, isDone) {
    const thumb = document.querySelector(`.vinyl-preview__thumb[data-upload-index="${uploadIndex}"]`);
    if (!thumb) return;
    const check = thumb.querySelector('.vinyl-preview__thumb-check');
    if (check) check.style.display = isDone ? '' : 'none';
  }

  /* ==========================================================================
     PREVIEW UPDATES
     ========================================================================== */
  function bindPreviewThumbs() {
    dom.previewThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = thumb.dataset.target;

        activatePreviewSlide(target);

        var activeStep = dom.accordion.querySelector('.vinyl-step--active');
        var activeStepNum = activeStep ? parseInt(activeStep.dataset.step, 10) : 0;

        var isCoverSlide = (target === 'front-cover' || target === 'back-cover');
        var isStickerSlide = (target === 'vinyl-a' || target === 'vinyl-b');

        if (isCoverSlide && (activeStepNum === 2 || activeStepNum === 3)) {
          return;
        }
        if (isStickerSlide && (activeStepNum === 4 || activeStepNum === 5)) {
          return;
        }

        const stepNum = PREVIEW_TO_STEP[target];
        if (stepNum) {
          openStepByNumber(stepNum);
        }
      });
    });
  }

  function updatePreview(index, imageUrl) {
    const mapping = {
      1: { slide: 'front-cover', selector: '.vinyl-preview__cover--front .vinyl-preview__image' },
      2: { slide: 'back-cover', selector: '.vinyl-preview__cover--back .vinyl-preview__image' },
      3: { slide: 'vinyl-a', selector: '.vinyl-preview__sticker--a .vinyl-preview__sticker-img' },
      4: { slide: 'vinyl-b', selector: '.vinyl-preview__sticker--b .vinyl-preview__sticker-img' }
    };

    const map = mapping[index];
    if (!map) return;

    const images = document.querySelectorAll(map.selector);
    const placeholders = document.querySelectorAll(`.vinyl-preview__slide[data-slide="${map.slide}"] .vinyl-preview__placeholder`);

    images.forEach((img) => {
      if (imageUrl) {
        img.src = imageUrl;
        img.style.display = 'block';
      } else {
        img.src = '';
        img.style.display = 'none';
      }
    });

    placeholders.forEach((ph) => {
      ph.style.display = imageUrl ? 'none' : '';
    });

    if (index === 1 || index === 2) {
      var coverEl = document.querySelector('.vinyl-preview__slide[data-slide="' + map.slide + '"] .vinyl-preview__cover');
      if (coverEl) coverEl.classList.toggle('vinyl-preview__cover--has-image', !!imageUrl);
    }

    /* Update full-set 2x2 grid cell */
    var fullGridMap = {
      1: 'front',
      2: 'back',
      3: 'vinyl-a',
      4: 'vinyl-b'
    };
    var fullKey = fullGridMap[index];
    if (fullKey) {
      var fullCell = document.querySelector('.vinyl-preview__full-cell[data-full="' + fullKey + '"]');
      if (fullCell) {
        if (index <= 2) {
          var fImg = fullCell.querySelector('.vinyl-preview__full-img');
          var fPh = fullCell.querySelector('.vinyl-preview__placeholder');
          if (fImg) {
            fImg.src = imageUrl || '';
            fImg.style.display = imageUrl ? 'block' : 'none';
          }
          if (fPh) fPh.style.display = imageUrl ? 'none' : '';
        } else {
          var fSticker = fullCell.querySelector('.vinyl-preview__sticker-img');
          var fPh2 = fullCell.querySelector('.vinyl-preview__placeholder');
          if (fSticker) {
            fSticker.src = imageUrl || '';
            fSticker.style.display = imageUrl ? 'block' : 'none';
          }
          if (fPh2) fPh2.style.display = imageUrl ? 'none' : '';
        }
      }
    }

    updateThumbImage(index, imageUrl);
    updateAllThumb();
  }

  function updateAllThumb() {
    var allThumb = document.querySelector('.vinyl-preview__thumb[data-upload-index="0"]');
    if (!allThumb) return;
    var thumbImg = allThumb.querySelector('.vinyl-preview__thumb-img');
    var thumbIcon = allThumb.querySelector('.vinyl-preview__thumb-icon');
    if (!thumbImg || !thumbIcon) return;

    var firstUrl = '';
    for (var i = 1; i <= 4; i++) {
      if (state.uploadedFiles[i] && (state.uploadedFiles[i].previewUrl || state.uploadedFiles[i].fileUrl)) {
        firstUrl = state.uploadedFiles[i].previewUrl || state.uploadedFiles[i].fileUrl;
        break;
      }
    }
    if (firstUrl) {
      thumbImg.src = firstUrl;
      thumbImg.style.display = '';
      thumbIcon.style.display = 'none';
    } else {
      thumbImg.src = '';
      thumbImg.style.display = 'none';
      thumbIcon.style.display = '';
    }
  }

  function updateThumbImage(uploadIndex, imageUrl) {
    const thumb = document.querySelector(`.vinyl-preview__thumb[data-upload-index="${uploadIndex}"]`);
    if (!thumb) return;

    const thumbImg = thumb.querySelector('.vinyl-preview__thumb-img');
    const thumbIcon = thumb.querySelector('.vinyl-preview__thumb-icon');

    if (thumbImg && thumbIcon) {
      if (imageUrl) {
        thumbImg.src = imageUrl;
        thumbImg.style.display = '';
        thumbIcon.style.display = 'none';
      } else {
        thumbImg.src = '';
        thumbImg.style.display = 'none';
        thumbIcon.style.display = '';
      }
    }
  }

  /* ==========================================================================
     STEP 2: COVER TEXT UI — Tabs, Font Preview, Live Preview
     ========================================================================== */
  function bindCoverTextUI() {
    var tabs = document.querySelectorAll('[data-cover-side]');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var side = tab.dataset.coverSide;
        tabs.forEach(function(t) { t.classList.remove('vinyl-text-tab--active'); });
        tab.classList.add('vinyl-text-tab--active');

        document.querySelectorAll('.vinyl-cover-text-panel').forEach(function(p) {
          p.style.display = p.dataset.coverPanel === side ? '' : 'none';
        });

        activatePreviewSlide(side === 'A' ? 'front-cover' : 'back-cover');
      });
    });

    ALL_COVER_KEYS.forEach(function(side) {
      var textInput = document.getElementById('coverText' + side);
      var fontSelect = document.getElementById('coverFont' + side);
      var sizeSelect = document.getElementById('coverSize' + side);
      var lhSelect = document.getElementById('coverLineHeight' + side);

      if (textInput) {
        textInput.addEventListener('input', function() {
          state.coverText[side].text = textInput.value;
          updateCoverTextPreview(side);
          refreshSiblingPreviews(side);
          updateStepCheckmarks();
        });
      }
      if (fontSelect) {
        fontSelect.addEventListener('change', function() {
          state.coverText[side].font = fontSelect.value;
          preloadFont(fontSelect.value, state.coverText[side].bold, state.coverText[side].italic);
          updateCoverTextPreview(side);
        });
      }
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function() {
          state.coverText[side].size = sizeSelect.value;
          updateCoverTextPreview(side);
        });
      }
      if (lhSelect) {
        lhSelect.addEventListener('change', function() {
          state.coverText[side].lineHeight = lhSelect.value;
          updateCoverTextPreview(side);
        });
      }

      var widthRange = document.getElementById('coverWidth' + side);
      var widthVal = document.getElementById('coverWidthVal' + side);
      if (widthRange && state.coverText[side].w !== undefined) {
        widthRange.addEventListener('input', function() {
          var w = parseInt(widthRange.value, 10);
          state.coverText[side].w = w;
          if (widthVal) widthVal.textContent = w + '%';
          updateCoverTextPreview(side);
        });
      }
    });

    initDraggableOverlays();
  }

  /* ==========================================================================
     DRAG-AND-DROP — Front cover text overlays
     ========================================================================== */
  function initDraggableOverlays() {
    ALL_COVER_KEYS.forEach(function(key) {
      var overlay = document.querySelector('[data-text-overlay="cover-' + key + '"]');
      if (!overlay) return;
      makeDraggable(overlay, key);
      makeResizable(overlay, key);
    });
  }

  function getPointerPos(e) {
    if (e.touches && e.touches.length) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    return { x: e.clientX, y: e.clientY };
  }

  function makeDraggable(el, fieldKey) {
    var isDragging = false;
    var startX, startY, elStartX, elStartY;

    function onDown(e) {
      if (e.target.closest('.vinyl-overlay__resize')) return;
      if (!state.coverText[fieldKey] || !state.coverText[fieldKey].text) return;
      isDragging = true;
      var pos = getPointerPos(e);
      startX = pos.x;
      startY = pos.y;
      var parent = el.parentElement;
      var rect = parent.getBoundingClientRect();
      elStartX = (parseFloat(el.style.left) || 50) / 100 * rect.width;
      elStartY = (parseFloat(el.style.top) || 50) / 100 * rect.height;
      el.classList.add('dragging');
      e.preventDefault();
    }

    function onMove(e) {
      if (!isDragging) return;
      var pos = getPointerPos(e);
      var dx = pos.x - startX;
      var dy = pos.y - startY;
      var parent = el.parentElement;
      var rect = parent.getBoundingClientRect();
      var padX = rect.width * 0.05;
      var padY = rect.height * 0.05;
      var newX = Math.max(padX, Math.min(rect.width - padX, elStartX + dx));
      var newY = Math.max(padY, Math.min(rect.height - padY, elStartY + dy));
      var pctX = (newX / rect.width) * 100;
      var pctY = (newY / rect.height) * 100;
      el.style.left = pctX + '%';
      el.style.top = pctY + '%';
    }

    function onUp() {
      if (!isDragging) return;
      isDragging = false;
      el.classList.remove('dragging');
      var pctX = parseFloat(el.style.left) || 50;
      var pctY = parseFloat(el.style.top) || 50;
      state.coverText[fieldKey].x = Math.round(pctX * 10) / 10;
      state.coverText[fieldKey].y = Math.round(pctY * 10) / 10;
      syncGridOverlay(fieldKey);
    }

    el.addEventListener('mousedown', onDown);
    el.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);
  }

  function makeResizable(overlay, fieldKey) {
    var handles = overlay.querySelectorAll('.vinyl-overlay__resize');
    if (!handles.length) return;

    var isResizing = false;
    var startX, startW, dir;

    handles.forEach(function(handle) {
      function onDown(e) {
        isResizing = true;
        dir = parseInt(handle.dataset.resizeDir, 10) || 1;
        var pos = getPointerPos(e);
        startX = pos.x;
        var parent = overlay.parentElement;
        startW = (state.coverText[fieldKey].w || 50) / 100 * parent.getBoundingClientRect().width;
        overlay.classList.add('resizing');
        e.preventDefault();
        e.stopPropagation();
      }
      handle.addEventListener('mousedown', onDown);
      handle.addEventListener('touchstart', onDown, { passive: false });
    });

    function onMove(e) {
      if (!isResizing) return;
      var pos = getPointerPos(e);
      var dx = (pos.x - startX) * dir;
      var parent = overlay.parentElement;
      var parentW = parent.getBoundingClientRect().width;
      var newW = Math.max(parentW * 0.15, Math.min(parentW, startW + dx));
      var pctW = (newW / parentW) * 100;
      overlay.style.width = pctW + '%';
    }

    function onUp() {
      if (!isResizing) return;
      isResizing = false;
      overlay.classList.remove('resizing');
      var pctW = parseFloat(overlay.style.width) || 50;
      var w = Math.round(pctW);
      state.coverText[fieldKey].w = w;
      var widthRange = document.getElementById('coverWidth' + fieldKey);
      var widthVal = document.getElementById('coverWidthVal' + fieldKey);
      if (widthRange) widthRange.value = w;
      if (widthVal) widthVal.textContent = w + '%';
      syncGridOverlay(fieldKey);
    }

    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);
  }

  function syncGridOverlay(key) {
    var gridOverlay = document.querySelector('[data-text-overlay-grid="cover-' + key + '"]');
    if (!gridOverlay || !state.coverText[key]) return;
    var data = state.coverText[key];
    gridOverlay.style.left = (data.x || 50) + '%';
    gridOverlay.style.top = (data.y || 50) + '%';
    gridOverlay.style.width = (data.w || 50) + '%';
  }

  /* ==========================================================================
     STEP 4: STICKER TEXT UI — Tabs, Live Preview
     ========================================================================== */
  function bindStickerTextUI() {
    var tabs = document.querySelectorAll('[data-sticker-side]');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var side = tab.dataset.stickerSide;
        tabs.forEach(function(t) { t.classList.remove('vinyl-text-tab--active'); });
        tab.classList.add('vinyl-text-tab--active');

        document.querySelectorAll('.vinyl-sticker-text-panel').forEach(function(p) {
          p.style.display = p.dataset.stickerPanel === side ? '' : 'none';
        });

        activatePreviewSlide(side === 'A' ? 'vinyl-a' : 'vinyl-b');
      });
    });

    ['A', 'B'].forEach(function(side) {
      var textInput = document.getElementById('stickerText' + side);
      var fontSelect = document.getElementById('stickerFont' + side);
      var sizeSelect = document.getElementById('stickerSize' + side);
      var lhSelect = document.getElementById('stickerLineHeight' + side);

      if (textInput) {
        textInput.addEventListener('input', function() {
          state.stickerText[side].text = textInput.value;
          updateStickerTextPreview(side);
          updateStepCheckmarks();
        });
      }
      if (fontSelect) {
        fontSelect.addEventListener('change', function() {
          state.stickerText[side].font = fontSelect.value;
          preloadFont(fontSelect.value, state.stickerText[side].bold, state.stickerText[side].italic);
          updateStickerTextPreview(side);
        });
      }
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function() {
          state.stickerText[side].size = sizeSelect.value;
          updateStickerTextPreview(side);
        });
      }
      if (lhSelect) {
        lhSelect.addEventListener('change', function() {
          state.stickerText[side].lineHeight = lhSelect.value;
          updateStickerTextPreview(side);
        });
      }
    });
  }

  /* ==========================================================================
     COLOR PICKERS — Pickr spectrum (cover text) + legacy syncColorToState
     ========================================================================== */
  var pickrInstances = {};

  function initSpectrumPickers() {
    if (typeof Pickr === 'undefined') {
      setTimeout(initSpectrumPickers, 200);
      return;
    }
    var root = document.querySelector('.vinyl-product');
    if (!root) root = document;
    root.querySelectorAll('.vinyl-color-picker--spectrum').forEach(function(wrapper) {
      var mountEl = wrapper.querySelector('.vinyl-pickr-mount');
      if (!mountEl || mountEl.dataset.pickrReady) return;

      var fieldGroup = wrapper.closest('.vinyl-text-field-group');
      var stickerPanel = wrapper.closest('.vinyl-sticker-text-panel');
      var fieldKey = '';
      var isCover = false;
      var isSticker = false;

      if (fieldGroup) {
        fieldKey = fieldGroup.dataset.fieldKey || '';
        isCover = true;
      } else if (stickerPanel) {
        fieldKey = stickerPanel.dataset.stickerPanel || '';
        isSticker = true;
      }
      if (!fieldKey) return;

      var savedColor = '#804040';
      if (isCover && state.coverText[fieldKey]) savedColor = state.coverText[fieldKey].color || '#804040';
      if (isSticker && state.stickerText[fieldKey]) savedColor = state.stickerText[fieldKey].color || '#804040';

      var pickr = Pickr.create({
        el: mountEl,
        theme: 'nano',
        useAsButton: true,
        inline: true,
        showAlways: true,
        default: savedColor,
        defaultRepresentation: 'HEXA',
        position: 'bottom-start',
        components: {
          preview: true,
          opacity: false,
          hue: true,
          interaction: {
            hex: true,
            input: true,
            save: true,
            clear: true,
            cancel: false
          }
        }
      });

      var _clearingText = false;

      pickr.on('change', function(color) {
        if (!color) return;
        var hex = color.toHEXA().toString().substring(0, 7);
        if (isCover && state.coverText[fieldKey]) {
          state.coverText[fieldKey].color = hex;
          updateCoverTextPreview(fieldKey);
        } else if (isSticker && state.stickerText[fieldKey]) {
          state.stickerText[fieldKey].color = hex;
          updateStickerTextPreview(fieldKey);
        }
        resetPickrSaveBtn(pickr);
        pickr.applyColor(false);
      });

      pickr.on('save', function(color) {
        if (_clearingText) return;
        if (!color) return;
        var hex = color.toHEXA().toString().substring(0, 7);
        if (isCover && state.coverText[fieldKey]) {
          state.coverText[fieldKey].color = hex;
          updateCoverTextPreview(fieldKey);
        } else if (isSticker && state.stickerText[fieldKey]) {
          state.stickerText[fieldKey].color = hex;
          updateStickerTextPreview(fieldKey);
        }
        saveState();
        flashPickrButton(getPickrBtn(pickr, 'save'), 'Saved!');
        var colorBlock = wrapper.closest('.vinyl-sticker-color-block');
        if (colorBlock) updateColorIndicator(colorBlock.id || (colorBlock.id = 'colorBlock_' + fieldKey), hex);
      });

      pickr.on('clear', function() {
        _clearingText = true;
        var resetColor = '#000000';
        if (isCover && state.coverText[fieldKey]) {
          state.coverText[fieldKey].color = resetColor;
          updateCoverTextPreview(fieldKey);
        } else if (isSticker && state.stickerText[fieldKey]) {
          state.stickerText[fieldKey].color = resetColor;
          updateStickerTextPreview(fieldKey);
        }
        saveState();
        pickr.setColor(resetColor);
        flashPickrButton(getPickrBtn(pickr, 'clear'), 'Cleared!');
        var colorBlock = wrapper.closest('.vinyl-sticker-color-block');
        if (colorBlock) updateColorIndicator(colorBlock.id || (colorBlock.id = 'colorBlock_' + fieldKey), resetColor);
        setTimeout(function() { _clearingText = false; }, 50);
      });

      mountEl.dataset.pickrReady = '1';
      pickrInstances[(isSticker ? 'sticker_' : '') + fieldKey] = pickr;
    });
  }

  function syncColorToState(picker, color) {
    var fieldGroup = picker.closest('.vinyl-text-field-group');
    if (fieldGroup) {
      var key = fieldGroup.dataset.fieldKey;
      if (state.coverText[key]) {
        state.coverText[key].color = color;
        updateCoverTextPreview(key);
        return;
      }
    }
    var panel = picker.closest('.vinyl-cover-text-panel');
    if (panel) {
      var side = panel.dataset.coverPanel;
      if (state.coverText[side]) {
        state.coverText[side].color = color;
        updateCoverTextPreview(side);
      }
      return;
    }
    var stickerPanel = picker.closest('.vinyl-sticker-text-panel');
    if (stickerPanel) {
      var sSide = stickerPanel.dataset.stickerPanel;
      state.stickerText[sSide].color = color;
      updateStickerTextPreview(sSide);
    }
  }

  /* ==========================================================================
     POSITION GRID — Cover text placement (9 positions)
     ========================================================================== */
  function bindPositionGrids() {
    document.querySelectorAll('.vinyl-position-grid').forEach(function(grid) {
      var buttons = grid.querySelectorAll('.vinyl-pos-btn');
      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          buttons.forEach(function(b) { b.classList.remove('vinyl-pos-btn--active'); });
          btn.classList.add('vinyl-pos-btn--active');

          var pos = btn.dataset.pos;
          var panel = grid.closest('.vinyl-cover-text-panel');
          if (panel) {
            var side = panel.dataset.coverPanel;
            state.coverText[side].position = pos;
            updateCoverTextPreview(side);
          }
        });
      });
    });
  }

  /* ==========================================================================
     PLACEMENT BUTTONS — Sticker text (above / below)
     ========================================================================== */
  function bindPlacementButtons() {
    document.querySelectorAll('.vinyl-sticker-placement').forEach(function(group) {
      var buttons = group.querySelectorAll('.vinyl-placement-btn');
      var panel = group.closest('.vinyl-sticker-text-panel');
      var side = panel ? panel.dataset.stickerPanel : '';
      var defaultPlacement = side ? state.stickerText[side].placement : '';

      buttons.forEach(function(btn) {
        if (defaultPlacement && btn.dataset.placement === defaultPlacement) {
          btn.classList.add('vinyl-placement-btn--active');
        }

        btn.addEventListener('click', function() {
          buttons.forEach(function(b) { b.classList.remove('vinyl-placement-btn--active'); });
          btn.classList.add('vinyl-placement-btn--active');

          var placement = btn.dataset.placement;
          if (panel) {
            var side = panel.dataset.stickerPanel;
            state.stickerText[side].placement = placement;
            updateStickerTextPreview(side);
          }
        });
      });
    });
  }

  /* ==========================================================================
     FORMAT TOOLBAR — Bold / Italic / Underline toggles
     ========================================================================== */
  function bindFormatToolbars() {
    document.querySelectorAll('.vinyl-format-toolbar').forEach(function(toolbar) {
      var target = toolbar.dataset.formatTarget;
      var buttons = toolbar.querySelectorAll('.vinyl-format-btn');

      buttons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          var format = btn.dataset.format;
          btn.classList.toggle('vinyl-format-btn--active');
          var isActive = btn.classList.contains('vinyl-format-btn--active');

          var fieldGroup = btn.closest('.vinyl-text-field-group');
          if (fieldGroup) {
            var key = fieldGroup.dataset.fieldKey;
            if (state.coverText[key]) {
              state.coverText[key][format] = isActive;
              if (format === 'bold' || format === 'italic') {
                preloadFont(state.coverText[key].font, state.coverText[key].bold, state.coverText[key].italic);
              }
              updateCoverTextPreview(key);
              return;
            }
          }

          if (target.startsWith('cover')) {
            var side = target.replace('cover', '');
            if (state.coverText[side]) {
              state.coverText[side][format] = isActive;
              if (format === 'bold' || format === 'italic') {
                preloadFont(state.coverText[side].font, state.coverText[side].bold, state.coverText[side].italic);
              }
              updateCoverTextPreview(side);
            }
          } else if (target.startsWith('sticker')) {
            var sSide = target.replace('sticker', '');
            state.stickerText[sSide][format] = isActive;
            if (format === 'bold' || format === 'italic') {
              preloadFont(state.stickerText[sSide].font, state.stickerText[sSide].bold, state.stickerText[sSide].italic);
            }
            updateStickerTextPreview(sSide);
          }
        });
      });
    });
  }

  /* ==========================================================================
     GOOGLE FONTS PREVIEW — Apply font-family to <option> elements
     ========================================================================== */
  function applyFontPreviews() {
    document.querySelectorAll('.vinyl-font-select').forEach(function(select) {
      Array.from(select.options).forEach(function(opt) {
        opt.style.fontFamily = '"' + opt.value + '", sans-serif';
      });
      select.style.fontFamily = '"' + select.value + '", sans-serif';
      select.addEventListener('change', function() {
        select.style.fontFamily = '"' + select.value + '", sans-serif';
      });
    });
  }

  /* ==========================================================================
     LIVE PREVIEW — Cover Text Overlay
     ========================================================================== */
  var FRONT_KEYS = ['A', 'A2', 'A3'];
  var BACK_KEYS = ['B', 'B2', 'B3', 'B4'];
  var ALL_COVER_KEYS = ['A', 'A2', 'A3', 'B', 'B2', 'B3', 'B4'];

  function refreshSiblingPreviews(side) {
    var prefix = side.charAt(0);
    ALL_COVER_KEYS.forEach(function(k) {
      if (k !== side && k.charAt(0) === prefix && state.coverText[k] && state.coverText[k].text) {
        updateCoverTextPreview(k);
      }
    });
  }

  function updateCoverTextPreview(side) {
    var overlayKey = 'cover-' + side;
    var overlay = document.querySelector('[data-text-overlay="' + overlayKey + '"]');
    var gridOverlay = document.querySelector('[data-text-overlay-grid="' + overlayKey + '"]');

    var data = state.coverText[side];
    if (!data) return;

    var isDraggable = ALL_COVER_KEYS.indexOf(side) !== -1;

    if (!data.text) {
      if (overlay) {
        overlay.style.display = 'none';
        overlay.style.textDecoration = 'none';
        overlay.style.fontWeight = 'normal';
        overlay.style.fontStyle = 'normal';
        var ts = overlay.querySelector('.vinyl-overlay__text');
        if (ts) {
          ts.textContent = '';
          ts.style.textDecoration = 'none';
          ts.style.fontWeight = 'normal';
          ts.style.fontStyle = 'normal';
        } else {
          overlay.textContent = '';
        }
      }
      if (gridOverlay) {
        gridOverlay.style.display = 'none';
        gridOverlay.style.textDecoration = 'none';
        gridOverlay.style.fontWeight = 'normal';
        gridOverlay.style.fontStyle = 'normal';
        gridOverlay.textContent = '';
      }
      return;
    }

    var fontFamily = '"' + data.font + '", sans-serif';
    var fontWeight = data.bold ? 'bold' : 'normal';
    var fontStyle = data.italic ? 'italic' : 'normal';
    var textDecor = data.underline ? 'underline' : 'none';
    var lineHeight = data.lineHeight || '1.2';
    var position = data.position || 'center';

    if (overlay) {
      var textSpan = overlay.querySelector('.vinyl-overlay__text');
      if (textSpan) {
        textSpan.textContent = data.text;
        textSpan.style.textDecoration = textDecor;
        textSpan.style.fontWeight = fontWeight;
        textSpan.style.fontStyle = fontStyle;
      } else {
        overlay.textContent = data.text;
      }

      overlay.style.fontFamily = fontFamily;
      overlay.style.color = data.color;
      var basePx = parseInt(data.size, 10) || 24;
      var scaledPx = Math.max(12, Math.min(36, Math.round(basePx * 0.45)));
      overlay.style.fontSize = scaledPx + 'px';
      overlay.style.lineHeight = lineHeight;
      overlay.style.fontWeight = fontWeight;
      overlay.style.fontStyle = fontStyle;
      overlay.style.textDecoration = 'none';
      overlay.style.overflow = 'visible';

      var zMap = { A: 5, A2: 6, A3: 7, B: 5, B2: 6, B3: 7, B4: 8 };
      overlay.style.zIndex = zMap[side] || 5;

      if (isDraggable) {
        overlay.style.display = 'block';
        overlay.style.position = 'absolute';
        overlay.style.inset = 'auto';
        overlay.style.left = (data.x || 50) + '%';
        overlay.style.top = (data.y || 50) + '%';
        overlay.style.width = (data.w || 50) + '%';
        overlay.style.transform = 'translate(-50%, -50%)';
      } else {
        overlay.style.display = 'flex';
        overlay.setAttribute('data-pos', position);
      }
    }

    if (gridOverlay) {
      gridOverlay.textContent = data.text;
      gridOverlay.style.display = 'flex';
      gridOverlay.style.fontFamily = fontFamily;
      gridOverlay.style.color = data.color;
      var gridPx = parseInt(data.size, 10) || 24;
      var gridScaled = Math.max(7, Math.round(gridPx * 0.22));
      gridOverlay.style.fontSize = gridScaled + 'px';
      gridOverlay.style.lineHeight = lineHeight;
      gridOverlay.style.fontWeight = fontWeight;
      gridOverlay.style.fontStyle = fontStyle;
      gridOverlay.style.textDecoration = textDecor;
      gridOverlay.style.overflow = 'visible';

      if (isDraggable) {
        gridOverlay.style.display = 'block';
        gridOverlay.style.position = 'absolute';
        gridOverlay.style.inset = 'auto';
        gridOverlay.style.left = (data.x || 50) + '%';
        gridOverlay.style.top = (data.y || 50) + '%';
        gridOverlay.style.transform = 'translate(-50%, -50%)';
        gridOverlay.style.width = (data.w || 50) + '%';
      } else {
        gridOverlay.setAttribute('data-pos', position);
      }
    }

    saveState();
  }

  /* ==========================================================================
     LIVE PREVIEW — Sticker Text Overlay
     ========================================================================== */
  function buildStickerSVG(data, side, sizeMultiplier, idSuffix) {
    var radius = 76;
    var cx = 100;
    var cy = 100;
    var isAbove = data.placement === 'above';
    var pathId = 'sticker-curve-' + side + '-' + data.placement + (idSuffix || '');
    var pathD;

    if (isAbove) {
      pathD = 'M ' + (cx - radius) + ',' + cy + ' A ' + radius + ',' + radius + ' 0 0,1 ' + (cx + radius) + ',' + cy;
    } else {
      pathD = 'M ' + (cx - radius) + ',' + cy + ' A ' + radius + ',' + radius + ' 0 0,0 ' + (cx + radius) + ',' + cy;
    }

    var fontSize = parseInt(data.size, 10) || 10;
    var scaledSize = Math.round(fontSize * (sizeMultiplier || 1.3));
    var fontWeight = data.bold ? 'bold' : 'normal';
    var fontStyle = data.italic ? 'italic' : 'normal';
    var textDecor = data.underline ? 'underline' : 'none';
    var fontFamily = "'" + data.font + "', sans-serif";
    var fillColor = data.color || '#FFFFFF';

    return '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">' +
      '<defs><path id="' + pathId + '" d="' + pathD + '" fill="none"/></defs>' +
      '<text font-family="' + fontFamily + '" font-size="' + scaledSize + '" fill="' + fillColor + '"' +
      ' font-weight="' + fontWeight + '" font-style="' + fontStyle + '" text-decoration="' + textDecor + '">' +
      '<textPath href="#' + pathId + '" startOffset="50%" text-anchor="middle">' +
      escapeHtml(data.text) +
      '</textPath></text></svg>';
  }

  function updateStickerTextPreview(side) {
    var aboveEl = document.querySelector('[data-sticker-text="' + side + '-above"]');
    var belowEl = document.querySelector('[data-sticker-text="' + side + '-below"]');
    var gridAboveEl = document.querySelector('[data-sticker-text-grid="' + side + '-above"]');
    var gridBelowEl = document.querySelector('[data-sticker-text-grid="' + side + '-below"]');

    var data = state.stickerText[side];
    if (!data.text) {
      if (aboveEl) { aboveEl.style.display = 'none'; aboveEl.innerHTML = ''; }
      if (belowEl) { belowEl.style.display = 'none'; belowEl.innerHTML = ''; }
      if (gridAboveEl) { gridAboveEl.style.display = 'none'; gridAboveEl.innerHTML = ''; }
      if (gridBelowEl) { gridBelowEl.style.display = 'none'; gridBelowEl.innerHTML = ''; }
      return;
    }

    var isAbove = data.placement === 'above';
    var targetEl = isAbove ? aboveEl : belowEl;
    var hideEl = isAbove ? belowEl : aboveEl;
    var gridTargetEl = isAbove ? gridAboveEl : gridBelowEl;
    var gridHideEl = isAbove ? gridBelowEl : gridAboveEl;

    if (hideEl) { hideEl.style.display = 'none'; hideEl.innerHTML = ''; }
    if (gridHideEl) { gridHideEl.style.display = 'none'; gridHideEl.innerHTML = ''; }

    if (targetEl) {
      targetEl.innerHTML = buildStickerSVG(data, side, 1.3, '');
      targetEl.style.display = 'block';
    }

    if (gridTargetEl) {
      gridTargetEl.innerHTML = buildStickerSVG(data, side, 1.3, '-grid');
      gridTargetEl.style.display = 'block';
    }

    saveState();
  }

  /* ==========================================================================
     MODALS (walkthrough, etc)
     ========================================================================== */
  function bindModals() {
    document.querySelectorAll('[data-modal]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const modalId = trigger.dataset.modal;
        const modal = document.getElementById(modalId);
        if (modal) modal.classList.add('active');
      });
    });

    document.querySelectorAll('.vinyl-modal__close').forEach((closeBtn) => {
      closeBtn.addEventListener('click', () => {
        const modal = closeBtn.closest('.vinyl-modal');
        if (modal) modal.classList.remove('active');
      });
    });

    document.querySelectorAll('.vinyl-modal').forEach((modal) => {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.classList.remove('active');
      });
    });
  }

  /* ==========================================================================
     MOBILE PREVIEW — Full scrollable preview of all customized elements
     ========================================================================== */
  function bindMobilePreview() {
    const trigger = document.getElementById('all_preview_trigger');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const previewModal = trigger.closest('.vinyl-mobile-preview').querySelector('.vinyl-modal--preview');
      if (!previewModal) return;

      const mobilePreview = previewModal.querySelector('#mobile_preview');
      if (!mobilePreview) return;

      mobilePreview.innerHTML = buildMobilePreviewHTML();
      previewModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    var closeBtn = document.querySelector('.vinyl-modal--preview .vinyl-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        document.body.style.overflow = '';
      });
    }
  }

  function buildMobilePreviewHTML() {
    var html = '<div class="mobile-preview-scroll">';

    var sections = [
      { id: 'element_1', label: 'Front Cover', dataSlide: 'front-cover' },
      { id: 'element_2', label: 'Back Cover', dataSlide: 'back-cover' },
      { id: 'element_3', label: 'Side A — Vinyl', dataSlide: 'vinyl-a' },
      { id: 'element_4', label: 'Side B — Vinyl', dataSlide: 'vinyl-b' }
    ];

    sections.forEach(function(sec) {
      var source = document.getElementById(sec.id);
      if (!source) return;

      html += '<div class="mobile-preview-section">';
      html += '<div class="mobile-preview-section__label">' + sec.label + '</div>';
      html += '<div class="mobile-preview-section__content">';

      var innerContent = source.querySelector('.vinyl-preview__cover, .vinyl-preview__record');
      if (innerContent) {
        html += '<div class="mobile-preview-section__item">' + innerContent.outerHTML + '</div>';
      }

      html += '</div></div>';
    });

    html += '</div>';
    return html;
  }

  /* ==========================================================================
     UTILITY FUNCTIONS
     ========================================================================== */
  function formatMoney(cents) {
    const symbol = config.currencySymbol || '$';
    const raw = (Math.abs(cents) / 100).toFixed(2);
    const amount = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return cents < 0 ? `-${symbol}${amount}` : `${symbol}${amount}`;
  }

  function formatDuration(seconds) {
    if (!seconds || isNaN(seconds)) return '00:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ==========================================================================
     IMAGE COMPOSITING ENGINE v3.0
     Bulletproof text overlay compositor for covers & stickers.
     Handles: all fonts, sizes, bold/italic/underline, all 9 positions,
     word-wrap, auto-scale, curved sticker text, safe zones.
     ========================================================================== */

  var MAX_CANVAS_SIZE = 3600;
  var COVER_MARGIN_PCT = 0.08;
  var STICKER_MAX_ARC = Math.PI * 0.78;
  var FONT_SCALE_REF = 600;
  var _fontCache = {};
  var _imageCache = {};

  /* ---------- Image helpers ---------- */

  function loadImageForCanvas(src) {
    return new Promise(function(resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function() { resolve(img); };
      img.onerror = function() {
        var img2 = new Image();
        img2.onload = function() { resolve(img2); };
        img2.onerror = reject;
        img2.src = src;
      };
      img.src = src;
    });
  }

  function getImageSrcFromUpload(upload) {
    if (upload.previewUrl) return upload.previewUrl;
    if (upload.fileUrl) return upload.fileUrl;
    if (upload.blob) return URL.createObjectURL(upload.blob);
    return null;
  }

  function precacheImageForCanvas(index) {
    var upload = state.uploadedFiles[index];
    if (!upload) return;
    var src = getImageSrcFromUpload(upload);
    if (!src || (_imageCache[index] && _imageCache[index].src === src)) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = src;
    _imageCache[index] = { src: src, ready: new Promise(function(resolve) {
      img.onload = function() { resolve(img); };
      img.onerror = function() {
        var img2 = new Image();
        img2.src = src;
        img2.onload = function() { resolve(img2); };
        img2.onerror = function() { resolve(null); };
      };
    })};
  }

  function getCachedImage(index) {
    var upload = state.uploadedFiles[index];
    if (!upload) return Promise.resolve(null);
    var src = getImageSrcFromUpload(upload);
    if (_imageCache[index] && _imageCache[index].src === src) return _imageCache[index].ready;
    precacheImageForCanvas(index);
    return _imageCache[index] ? _imageCache[index].ready : loadImageForCanvas(src);
  }

  /* ---------- Font helpers ---------- */

  function injectFontCSS(fontFamily, weight, ital) {
    var id = 'gf-' + fontFamily.replace(/\s+/g, '-') + '-' + weight + '-' + ital;
    if (document.getElementById(id)) return;
    var link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=' +
      encodeURIComponent(fontFamily) + ':ital,wght@' + ital + ',' + weight + '&display=swap';
    document.head.appendChild(link);
  }

  function loadFontForCanvas(fontFamily, bold, italic) {
    var w = bold ? 700 : 400;
    var it = italic ? 1 : 0;
    var key = fontFamily + '|' + w + '|' + it;
    if (_fontCache[key]) return _fontCache[key];

    injectFontCSS(fontFamily, 400, 0);
    if (w !== 400) injectFontCSS(fontFamily, w, 0);
    if (it !== 0)  injectFontCSS(fontFamily, 400, it);
    if (w !== 400 && it !== 0) injectFontCSS(fontFamily, w, it);

    var spec = (italic ? 'italic ' : '') + (bold ? 'bold ' : '') + '20px "' + fontFamily + '"';

    _fontCache[key] = new Promise(function(resolve) {
      var done = false;
      var finish = function(label) {
        if (done) return;
        done = true;
        console.log('[Vinyl Font]', label, fontFamily, 'w=' + w, 'i=' + it);
        resolve();
      };
      setTimeout(function() { finish('timeout'); }, 800);
      document.fonts.load(spec).then(function() {
        finish('loaded');
      }).catch(function() {
        finish('fallback');
      });
    });

    return _fontCache[key];
  }

  function preloadFont(fontFamily, bold, italic) {
    loadFontForCanvas(fontFamily, bold || false, italic || false);
  }

  /* ---------- Canvas font string ---------- */

  function buildCanvasFont(data, fontSize) {
    var s = '';
    if (data.italic) s += 'italic ';
    if (data.bold)   s += 'bold ';
    s += Math.round(fontSize) + 'px "' + (data.font || data.fontFamily || 'sans-serif') + '", sans-serif';
    return s;
  }

  /* ---------- Word wrap (handles single long words) ---------- */

  function wrapText(ctx, text, maxW) {
    if (!text) return [''];
    var words = text.split(' ');
    var lines = [];
    var cur = '';

    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      if (ctx.measureText(word).width > maxW && word.length > 1) {
        if (cur) { lines.push(cur); cur = ''; }
        var partial = '';
        for (var c = 0; c < word.length; c++) {
          var test = partial + word[c];
          if (ctx.measureText(test).width > maxW && partial) {
            lines.push(partial);
            partial = word[c];
          } else {
            partial = test;
          }
        }
        cur = partial;
      } else {
        var testLine = cur ? (cur + ' ' + word) : word;
        if (ctx.measureText(testLine).width > maxW && cur) {
          lines.push(cur);
          cur = word;
        } else {
          cur = testLine;
        }
      }
    }
    if (cur) lines.push(cur);
    return lines.length ? lines : [''];
  }

  /* ---------- Measure widest line ---------- */

  function measureWidest(ctx, lines) {
    var max = 0;
    for (var i = 0; i < lines.length; i++) {
      var w = ctx.measureText(lines[i]).width;
      if (w > max) max = w;
    }
    return max;
  }

  /* ---------- Wrap + auto-scale until fits (Canvas-only fallback) ---------- */

  function fitTextToWidth(ctx, textData, inputLines, maxW, initialSize, minSize) {
    var fs = initialSize;
    var lines, widest;

    for (var attempt = 0; attempt < 30; attempt++) {
      ctx.font = buildCanvasFont(textData, fs);
      lines = [];
      for (var i = 0; i < inputLines.length; i++) {
        var wrapped = wrapText(ctx, inputLines[i], maxW);
        for (var j = 0; j < wrapped.length; j++) lines.push(wrapped[j]);
      }
      widest = measureWidest(ctx, lines);

      if (widest <= maxW || fs <= minSize) break;

      var ratio = maxW / widest * 0.93;
      var newFs = Math.floor(fs * ratio);
      if (newFs >= fs) newFs = fs - 1;
      fs = Math.max(minSize, newFs);
    }

    return { lines: lines, fontSize: fs, widest: widest, attempts: attempt };
  }

  /* ---------- Scale font to fit LOCKED lines (no re-wrapping) ---------- */

  function fitLockedLines(ctx, textData, lockedLines, maxW, initialSize, minSize) {
    var fs = initialSize;
    var widest;

    for (var attempt = 0; attempt < 30; attempt++) {
      ctx.font = buildCanvasFont(textData, fs);
      widest = measureWidest(ctx, lockedLines);

      if (widest <= maxW || fs <= minSize) break;

      var ratio = maxW / widest * 0.96;
      var newFs = Math.floor(fs * ratio);
      if (newFs >= fs) newFs = fs - 1;
      fs = Math.max(minSize, newFs);
    }

    return { lines: lockedLines, fontSize: fs, widest: widest, attempts: attempt };
  }

  /* ---------- CSS line-break detection (matches preview exactly) ---------- */

  function getCSSLineBreaks(text, textData, containerWidth) {
    if (!text || containerWidth <= 0) return [text || ''];

    var fontSize = Math.max(8, Math.round((parseInt(textData.size, 10) || 24) * 0.6));
    var fontWeight = textData.bold ? 'bold' : 'normal';
    var fontStyle = textData.italic ? 'italic' : 'normal';
    var fontFamily = '"' + (textData.font || 'sans-serif') + '", sans-serif';
    var lineHeight = textData.lineHeight || '1.2';

    var el = document.createElement('div');
    el.style.cssText =
      'position:absolute;left:-9999px;top:0;visibility:hidden;' +
      'width:' + containerWidth + 'px;' +
      'font-family:' + fontFamily + ';' +
      'font-size:' + fontSize + 'px;' +
      'font-weight:' + fontWeight + ';' +
      'font-style:' + fontStyle + ';' +
      'line-height:' + lineHeight + ';' +
      'word-break:break-word;' +
      'white-space:normal;' +
      'padding:0;margin:0;border:0;';

    el.textContent = text;
    document.body.appendChild(el);

    var textNode = el.firstChild;
    if (!textNode || textNode.nodeType !== 3) {
      document.body.removeChild(el);
      return [text];
    }

    var lines = [];
    var range = document.createRange();
    var lastTop = -99999;
    var lineStart = 0;
    var len = text.length;

    for (var i = 0; i < len; i++) {
      range.setStart(textNode, i);
      range.setEnd(textNode, Math.min(i + 1, len));
      var rects = range.getClientRects();
      if (rects.length === 0) continue;
      var top = rects[0].top;

      if (lastTop > -99999 && Math.abs(top - lastTop) > 2) {
        var seg = text.substring(lineStart, i).trim();
        if (seg) lines.push(seg);
        lineStart = i;
        while (lineStart < len && text[lineStart] === ' ') lineStart++;
        i = Math.max(i, lineStart - 1);
      }
      lastTop = top;
    }

    var remaining = text.substring(lineStart).trim();
    if (remaining) lines.push(remaining);

    document.body.removeChild(el);

    console.log('[CSS Lines]', JSON.stringify(lines), '| containerW:', containerWidth,
      '| font:', fontSize + 'px', fontWeight, fontStyle, textData.font);

    return lines.length > 0 ? lines : [text];
  }

  /* ---------- Cover text position (all 9 placements) ---------- */

  function getCoverPosition(placement, canvasW, canvasH, totalTextH, fontSize, pad) {
    var mx = pad || Math.round(canvasW * COVER_MARGIN_PCT);
    var my = mx;
    var ascent = fontSize * 0.78;

    var xMap = { 'left': mx, 'center': canvasW / 2, 'right': canvasW - mx };
    var alignMap = { 'left': 'left', 'center': 'center', 'right': 'right' };

    var parts = (placement || 'center').split('-');
    var vPos, hPos;
    if (parts.length === 1) {
      vPos = 'middle'; hPos = parts[0];
      if (parts[0] === 'center') { vPos = 'middle'; hPos = 'center'; }
    } else {
      vPos = parts[0]; hPos = parts[1];
    }

    var x = xMap[hPos] !== undefined ? xMap[hPos] : canvasW / 2;
    var align = alignMap[hPos] || 'center';

    var baselineY;
    if (vPos === 'top') {
      baselineY = my + ascent;
    } else if (vPos === 'bottom') {
      baselineY = canvasH - my - totalTextH + ascent;
    } else {
      baselineY = (canvasH - totalTextH) / 2 + ascent;
    }

    return { x: x, baselineY: baselineY, align: align };
  }

  /* ---------- Draw cover text block ---------- */

  function drawCoverText(ctx, lines, fontSize, textData, canvasW, canvasH, pad) {
    var lineHeight = parseFloat(textData.lineHeight) || 1.2;
    var lhPx = Math.round(fontSize * lineHeight);
    var totalH = lines.length * lhPx;
    var effectivePad = pad || Math.round(canvasW * COVER_MARGIN_PCT);
    var maxW = canvasW - effectivePad * 2;
    var hardLimit = maxW + Math.round(effectivePad * 0.3);

    var pos = getCoverPosition(textData.position, canvasW, canvasH, totalH, fontSize, effectivePad);

    ctx.font = buildCanvasFont(textData, fontSize);
    ctx.fillStyle = textData.color || '#FFFFFF';
    ctx.textAlign = pos.align;
    ctx.textBaseline = 'alphabetic';

    var scale = canvasW / FONT_SCALE_REF;
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;

    for (var i = 0; i < lines.length; i++) {
      var y = pos.baselineY + i * lhPx;
      ctx.fillText(lines[i], pos.x, y, hardLimit);
    }

    if (textData.underline) {
      ctx.shadowColor = 'transparent';
      ctx.strokeStyle = textData.color || '#FFFFFF';
      ctx.lineWidth = Math.max(2, Math.round(fontSize * 0.06));

      for (var i = 0; i < lines.length; i++) {
        var y = pos.baselineY + i * lhPx;
        var uy = y + Math.round(fontSize * 0.1);
        var lw = Math.min(ctx.measureText(lines[i]).width, hardLimit);
        var lx = pos.x;

        if (pos.align === 'center') lx -= lw / 2;
        else if (pos.align === 'right') lx -= lw;

        ctx.beginPath();
        ctx.moveTo(lx, uy);
        ctx.lineTo(lx + lw, uy);
        ctx.stroke();
      }
    }
  }

  /* ============================================================
   *  COVER COMPOSITOR — html2canvas DOM capture
   *  Captures the EXACT text overlay from the preview DOM element
   *  and composites it onto the full-resolution base image.
   *  This guarantees 100% visual match between preview and Order.
   * ============================================================ */

  function ensureSlideVisible(slideDataAttr) {
    var slide = document.querySelector('[data-slide="' + slideDataAttr + '"]');
    if (!slide) return { slide: null, restore: function() {} };

    var computed = window.getComputedStyle(slide);
    var wasHidden = (computed.display === 'none' || slide.offsetWidth === 0);
    var origStyle = slide.getAttribute('style') || '';

    if (wasHidden) {
      slide.setAttribute('style', origStyle +
        ';display:block !important;position:fixed !important;' +
        'top:-9999px !important;left:0 !important;' +
        'width:500px !important;height:500px !important;' +
        'visibility:visible !important;z-index:-1 !important;' +
        'pointer-events:none !important;');
      slide.offsetHeight;
    }

    return {
      slide: slide,
      restore: function() {
        if (wasHidden) slide.setAttribute('style', origStyle);
      }
    };
  }

  function captureOverlayWithHtml2Canvas(overlay, targetW, targetH) {
    if (typeof html2canvas === 'undefined') {
      console.warn('[Compositor] html2canvas not loaded, using Canvas fallback');
      return Promise.resolve(null);
    }

    var elW = overlay.offsetWidth;
    var elH = overlay.offsetHeight;
    if (elW < 10 || elH < 10) {
      console.warn('[Compositor] overlay has no dimensions:', elW, elH);
      return Promise.resolve(null);
    }

    var captureScale = Math.max(targetW / elW, targetH / elH);
    captureScale = Math.min(captureScale, 6);

    console.log('[html2canvas] Capturing overlay',
      '| el:', elW + 'x' + elH,
      '| target:', targetW + 'x' + targetH,
      '| scale:', captureScale.toFixed(2));

    return html2canvas(overlay, {
      backgroundColor: null,
      scale: captureScale,
      logging: false,
      useCORS: true,
      allowTaint: true
    }).then(function(capturedCanvas) {
      console.log('[html2canvas] Captured:',
        capturedCanvas.width + 'x' + capturedCanvas.height);
      return capturedCanvas;
    }).catch(function(err) {
      console.error('[html2canvas] Capture failed:', err);
      return null;
    });
  }

  function canvasFallbackComposite(baseImg, w, h, td, side, outMime) {
    var canvas = document.createElement('canvas');
    canvas.width = w; canvas.height = h;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(baseImg, 0, 0, w, h);

    var cScale = w / FONT_SCALE_REF;
    var initSize = Math.round((parseInt(td.size, 10) || 24) * cScale);
    var minSize = Math.max(8, Math.round(10 * cScale));
    var maxW = w - Math.round(w * COVER_MARGIN_PCT) * 2;
    var inputLines = td.text.split('\n');
    var fit = fitTextToWidth(ctx, td, inputLines, maxW, initSize, minSize);

    console.log('[Vinyl Cover ' + side + ' FALLBACK]',
      '| font:', fit.fontSize + 'px', '| lines:', fit.lines.length);

    drawCoverText(ctx, fit.lines, fit.fontSize, td, w, h);

    var mime = (outMime === 'image/png' || outMime === 'image/webp') ? outMime : 'image/jpeg';
    var quality = mime === 'image/png' ? undefined : 0.97;
    return new Promise(function(resolve) {
      canvas.toBlob(function(blob) {
        if (!blob) {
          var dataUrl = canvas.toDataURL(mime, quality);
          fetch(dataUrl).then(function(r) { return r.blob(); }).then(resolve)
            .catch(function() { resolve(null); });
        } else { resolve(blob); }
      }, mime, quality);
    });
  }

  function compositeCoverImage(side) {
    var idx = side === 'A' ? 1 : 2;
    var upload = state.uploadedFiles[idx];

    var keys = side === 'A' ? FRONT_KEYS : BACK_KEYS;
    var hasAnyText = keys.some(function(k) { return state.coverText[k] && state.coverText[k].text; });
    if (!upload || !hasAnyText) return Promise.resolve(null);
    if (upload.isPassthrough) {
      console.log('[Vinyl Cover ' + side + '] passthrough (PDF/TIFF) — skipping text composite, sending original file');
      return Promise.resolve(null);
    }

    var sourceMime = upload.mime || 'image/jpeg';
    var outMime = (sourceMime === 'image/png' || sourceMime === 'image/webp') ? sourceMime : 'image/jpeg';
    var quality = outMime === 'image/png' ? undefined : 0.97;

    return getCachedImage(idx).then(function(baseImg) {
      if (!baseImg) return null;
      var t0 = performance.now();

      var ow = baseImg.naturalWidth, oh = baseImg.naturalHeight;
      var sc = 1;
      if (Math.max(ow, oh) > MAX_CANVAS_SIZE) sc = MAX_CANVAS_SIZE / Math.max(ow, oh);
      var w = Math.round(ow * sc), h = Math.round(oh * sc);

      var finalCanvas = document.createElement('canvas');
      finalCanvas.width = w;
      finalCanvas.height = h;
      var ctx = finalCanvas.getContext('2d');
      ctx.drawImage(baseImg, 0, 0, w, h);

      keys.forEach(function(key) {
        var td = state.coverText[key];
        if (!td || !td.text) return;

        var cScale = w / FONT_SCALE_REF;
        var initSize = Math.round((parseInt(td.size, 10) || 24) * cScale);
        var minSize = Math.max(8, Math.round(10 * cScale));
        var maxW = w - Math.round(w * COVER_MARGIN_PCT) * 2;
        var inputLines = td.text.split('\n');
        var fit = fitTextToWidth(ctx, td, inputLines, maxW, initSize, minSize);
        drawCoverText(ctx, fit.lines, fit.fontSize, td, w, h);
      });

      console.log('[Vinyl Cover ' + side + ' COMPOSITE]',
        ow + 'x' + oh, '→', w + 'x' + h, '(' + outMime + ')',
        '| layers:', keys.filter(function(k) { return state.coverText[k] && state.coverText[k].text; }).length,
        '| time:', Math.round(performance.now() - t0), 'ms');

      return new Promise(function(resolve) {
        finalCanvas.toBlob(function(blob) {
          if (!blob) {
            var dataUrl = finalCanvas.toDataURL(outMime, quality);
            fetch(dataUrl).then(function(r) { return r.blob(); })
              .then(resolve).catch(function() { resolve(null); });
          } else { resolve(blob); }
        }, outMime, quality);
      });
    }).catch(function(err) {
      console.error('[Vinyl Cover ' + side + '] FATAL:', err);
      return null;
    });
  }

  /* ---------- Curved text for stickers ---------- */

  function drawCurvedText(ctx, text, cx, cy, radius, isAbove, opts) {
    ctx.save();
    var fs = opts.fontSize;
    ctx.font = buildCanvasFont(opts, fs);
    ctx.fillStyle = opts.color || '#000000';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;

    var chars = [];
    for (var i = 0; i < text.length; i++) {
      var cw = ctx.measureText(text[i]).width;
      chars.push({ ch: text[i], w: cw, a: cw / radius });
    }
    var totalA = 0;
    for (var i = 0; i < chars.length; i++) totalA += chars[i].a;

    var charSpacing = fs * 0.04 / radius;

    if (isAbove) {
      var a = -Math.PI / 2 - (totalA + charSpacing * (chars.length - 1)) / 2;
      for (var i = 0; i < chars.length; i++) {
        a += chars[i].a / 2;
        ctx.save();
        ctx.translate(cx + radius * Math.cos(a), cy + radius * Math.sin(a));
        ctx.rotate(a + Math.PI / 2);
        ctx.fillText(chars[i].ch, 0, 0);
        ctx.restore();
        a += chars[i].a / 2 + charSpacing;
      }
    } else {
      var a = Math.PI / 2 + (totalA + charSpacing * (chars.length - 1)) / 2;
      for (var i = 0; i < chars.length; i++) {
        a -= chars[i].a / 2;
        ctx.save();
        ctx.translate(cx + radius * Math.cos(a), cy + radius * Math.sin(a));
        ctx.rotate(a - Math.PI / 2);
        ctx.fillText(chars[i].ch, 0, 0);
        ctx.restore();
        a -= chars[i].a / 2 + charSpacing;
      }
    }
    ctx.restore();
  }

  /* ---------- STICKER COMPOSITOR ---------- */

  function compositeStickerImage(side) {
    var idx = side === 'A' ? 3 : 4;
    var upload = state.uploadedFiles[idx];
    var td = state.stickerText[side];
    if (!upload || !td || !td.text) return Promise.resolve(null);
    if (upload.isPassthrough) {
      console.log('[Vinyl Sticker ' + side + '] passthrough (PDF/TIFF) — skipping curved-text composite, sending original file');
      return Promise.resolve(null);
    }

    return getCachedImage(idx).then(function(img) {
      if (!img) return null;
      var t0 = performance.now();

      var origDim = Math.max(img.naturalWidth, img.naturalHeight);
      var dim = Math.min(origDim, MAX_CANVAS_SIZE);

      var canvas = document.createElement('canvas');
      canvas.width = dim; canvas.height = dim;
      var ctx = canvas.getContext('2d');

      ctx.save();
      ctx.beginPath();
      ctx.arc(dim / 2, dim / 2, dim / 2, 0, Math.PI * 2);
      ctx.clip();
      var r = img.naturalWidth / img.naturalHeight;
      var dw = dim, dh = dim, dx = 0, dy = 0;
      if (r > 1) { dw = dim * r; dx = (dim - dw) / 2; }
      else if (r < 1) { dh = dim / r; dy = (dim - dh) / 2; }
      ctx.drawImage(img, dx, dy, dw, dh);
      ctx.restore();

      var scale = dim / 200;
      var initFs = Math.round((parseInt(td.size, 10) || 12) * 1.3 * scale);
      var isAbove = td.placement === 'above';
      var radius = Math.round(82 * scale);

      ctx.font = buildCanvasFont(td, initFs);
      var totalCharW = 0;
      for (var i = 0; i < td.text.length; i++) {
        totalCharW += ctx.measureText(td.text[i]).width;
      }
      var charSpace = initFs * 0.04;
      var totalArc = (totalCharW + charSpace * (td.text.length - 1)) / radius;

      var fs = initFs;
      var scaleAttempts = 0;
      while (totalArc > STICKER_MAX_ARC && fs > 6) {
        var shrink = STICKER_MAX_ARC / totalArc * 0.92;
        fs = Math.max(6, Math.floor(fs * shrink));
        ctx.font = buildCanvasFont(td, fs);
        totalCharW = 0;
        for (var i = 0; i < td.text.length; i++) {
          totalCharW += ctx.measureText(td.text[i]).width;
        }
        charSpace = fs * 0.04;
        totalArc = (totalCharW + charSpace * (td.text.length - 1)) / radius;
        scaleAttempts++;
        if (scaleAttempts > 20) break;
      }

      console.log('[Vinyl Sticker ' + side + ']', origDim + '→' + dim + 'px',
        '| font:', td.font, '| req:', td.size, '→', fs + 'px',
        '| arc:', Math.round(totalArc * 180 / Math.PI) + '°/' + Math.round(STICKER_MAX_ARC * 180 / Math.PI) + '°',
        '| placement:', td.placement, '| scaled:', scaleAttempts > 0);

      drawCurvedText(ctx, td.text, dim / 2, dim / 2, radius, isAbove, {
        font: td.font, fontFamily: td.font, fontSize: fs,
        color: td.color || '#000000',
        bold: td.bold, italic: td.italic, underline: td.underline
      });

      console.log('[Vinyl Sticker ' + side + '] done in', Math.round(performance.now() - t0), 'ms (PNG lossless, transparency preserved)');

      return new Promise(function(resolve) {
        canvas.toBlob(function(blob) {
          if (!blob) {
            var dataUrl = canvas.toDataURL('image/png');
            fetch(dataUrl).then(function(r) { return r.blob(); }).then(resolve).catch(function() { resolve(null); });
          } else {
            resolve(blob);
          }
        }, 'image/png');
      });
    }).catch(function(err) {
      console.error('[Vinyl Sticker ' + side + '] ERROR:', err);
      return null;
    });
  }

  /* ---------- GENERATE ALL ---------- */

  function generateCompositedImages() {
    var results = {};
    var fontLoads = [];

    ALL_COVER_KEYS.forEach(function(side) {
      var ct = state.coverText[side];
      if (ct && ct.text) fontLoads.push(loadFontForCanvas(ct.font, ct.bold, ct.italic));
    });
    ['A', 'B'].forEach(function(side) {
      var st = state.stickerText[side];
      if (st && st.text) fontLoads.push(loadFontForCanvas(st.font, st.bold, st.italic));
    });

    var t0 = performance.now();

    return Promise.all(fontLoads).then(function() {
      console.log('[Vinyl] All fonts ready in', Math.round(performance.now() - t0), 'ms');

      function fileFromBlob(blob, baseName) {
        var ext = extFromMime(blob.type);
        return new File([blob], baseName + '.' + ext, { type: blob.type || 'image/jpeg' });
      }
      return Promise.all([
        compositeCoverImage('A').then(function(b) {
          if (b) results.coverA = fileFromBlob(b, 'front_cover_with_text');
        }),
        compositeCoverImage('B').then(function(b) {
          if (b) results.coverB = fileFromBlob(b, 'back_cover_with_text');
        }),
        compositeStickerImage('A').then(function(b) {
          if (b) results.stickerA = fileFromBlob(b, 'sticker_a_with_text');
        }),
        compositeStickerImage('B').then(function(b) {
          if (b) results.stickerB = fileFromBlob(b, 'sticker_b_with_text');
        })
      ]).then(function() {
        console.log('[Vinyl] Compositing complete in', Math.round(performance.now() - t0), 'ms —',
          'coverA:', results.coverA ? (results.coverA.size + 'b ' + results.coverA.type) : 'skip',
          'coverB:', results.coverB ? (results.coverB.size + 'b ' + results.coverB.type) : 'skip',
          'stickerA:', results.stickerA ? (results.stickerA.size + 'b ' + results.stickerA.type) : 'skip',
          'stickerB:', results.stickerB ? (results.stickerB.size + 'b ' + results.stickerB.type) : 'skip');
        return results;
      });
    });
  }

  /* ---------- DEBUG: test compositor from console ---------- */

  window._vinylTestComposite = function() {
    console.log('=== VINYL COMPOSITOR TEST ===');
    console.log('Cover A text:', state.coverText.A.text || '(empty)');
    console.log('Cover B text:', state.coverText.B.text || '(empty)');
    console.log('Sticker A text:', state.stickerText.A.text || '(empty)');
    console.log('Sticker B text:', state.stickerText.B.text || '(empty)');
    console.log('Uploaded files:', Object.keys(state.uploadedFiles).join(', ') || '(none)');
    generateCompositedImages().then(function(r) {
      console.log('=== TEST RESULTS ===');
      for (var k in r) {
        if (r[k]) {
          var url = URL.createObjectURL(r[k]);
          console.log(k + ':', r[k].size, 'bytes →', url);
          window.open(url, '_blank');
        }
      }
    }).catch(function(e) { console.error('Test failed:', e); });
  };

  /* ==========================================================================
     CUSTOM ELEMENT: product-form
     ========================================================================== */
  function uploadBlobToShopifyCdn(blob, filename) {
    return new Promise(function(resolve) {
      _cdnUploadQueue = _cdnUploadQueue.then(function() {
        return new Promise(function(done) {
          var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
          var variantId = variantInput ? variantInput.value : (config.variantId || '');
          if (!variantId) { console.warn('[Vinyl] No variant for CDN upload'); resolve(blob); done(); return; }

          var propKey = '_img_' + Date.now() + '_' + Math.random().toString(36).substring(2, 6);
          var frameName = 'vinyl_img_frame_' + Date.now();

          var iframe = document.createElement('iframe');
          iframe.name = frameName;
          iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none';
          document.body.appendChild(iframe);

          var form = document.createElement('form');
          form.method = 'POST';
          form.action = '/cart/add';
          form.enctype = 'multipart/form-data';
          form.target = frameName;
          form.style.display = 'none';

          var inp = function(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; form.appendChild(i); };
          inp('id', variantId);
          inp('quantity', '1');

          var fileInput = document.createElement('input');
          fileInput.type = 'file';
          fileInput.name = 'properties[' + propKey + ']';
          fileInput.style.display = 'none';
          var fallbackName = filename || ('image.' + extFromMime(blob && blob.type));
          try {
            var file = (blob instanceof File) ? blob : new File([blob], fallbackName, { type: blob.type || 'image/jpeg' });
            var dt = new DataTransfer();
            dt.items.add(file);
            fileInput.files = dt.files;
          } catch (e) {
            console.warn('[Vinyl] DataTransfer not supported for image upload');
            resolve(blob); done(); return;
          }
          form.appendChild(fileInput);
          document.body.appendChild(form);

          console.log('[Vinyl] Uploading image to Shopify CDN via native form:', filename || 'image.jpg', '(' + ((blob.size || 0) / 1024).toFixed(0) + 'KB)');

          var attempts = 0;
          var maxAttempts = 40;

          function poll() {
            attempts++;
            fetch('/cart.js')
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                var cdnUrl = '';
                var itemKey = '';

                for (var i = 0; i < cart.items.length; i++) {
                  var p = cart.items[i].properties;
                  if (p && p[propKey] !== undefined) {
                    itemKey = cart.items[i].key;
                    var val = typeof p[propKey] === 'string' ? p[propKey] : '';
                    if (val.indexOf('cdn.shopify.com') !== -1) {
                      cdnUrl = val;
                    }
                    break;
                  }
                }

                if (!cdnUrl && attempts < maxAttempts) {
                  if (attempts % 5 === 0) console.log('[Vinyl] Polling CDN URL for image... attempt', attempts);
                  setTimeout(poll, 500);
                  return;
                }

                console.log('[Vinyl] Image CDN result:', cdnUrl ? cdnUrl : 'FAILED after ' + attempts + ' attempts');

                var cleanup = itemKey
                  ? fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: itemKey, quantity: 0 }) }).catch(function() {})
                  : Promise.resolve();

                cleanup.then(function() {
                  try { form.remove(); iframe.remove(); } catch(e) {}
                  if (cdnUrl) {
                    resolve(cdnUrl);
                  } else {
                    resolve(blob);
                  }
                  done();
                });
              })
              .catch(function() {
                if (attempts < maxAttempts) { setTimeout(poll, 500); }
                else {
                  try { form.remove(); iframe.remove(); } catch(e) {}
                  resolve(blob);
                  done();
                }
              });
          }

          form.submit();
          setTimeout(poll, 2000);
        });
      });
    });
  }

  function uploadBlobToFilestack(blob, filename) {
    if (!FILESTACK_API_KEY) {
      return uploadBlobToShopifyCdn(blob, filename);
    }
    var name = filename || ('image.' + extFromMime(blob && blob.type));
    var fd = new FormData();
    fd.append('fileUpload', blob, name);
    fd.append('filename', name);
    if (blob && blob.type) fd.append('mimetype', blob.type);
    return fetch('https://www.filestackapi.com/api/store/S3?key=' + FILESTACK_API_KEY, {
      method: 'POST',
      body: fd
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Filestack HTTP ' + res.status);
      return res.text();
    })
    .then(function(text) {
      try {
        var data = JSON.parse(text);
        if (data.url) {
          // Append ?dl=true so admin clicks in the Shopify order trigger a
          // download (Content-Disposition: attachment) instead of opening
          // the image inline. Filename + extension still come from the
          // `filename` multipart field sent above.
          var publicUrl = data.url + '?dl=true';
          console.log('[Vinyl] Composited image uploaded to Filestack:', publicUrl);
          return publicUrl;
        }
        throw new Error('No URL in response');
      } catch (e) {
        if (text.indexOf('blocked') !== -1 || text.indexOf('error') !== -1) {
          throw new Error('Filestack blocked: ' + text.substring(0, 100));
        }
        throw e;
      }
    })
    .catch(function(err) {
      console.warn('[Vinyl] Filestack failed, falling back to Shopify CDN:', err.message || err);
      return uploadBlobToShopifyCdn(blob, filename);
    });
  }

  function batchUploadBlobsToShopifyCdn(blobMap) {
    var keys = Object.keys(blobMap);
    if (!keys.length) return Promise.resolve({});

    var results = {};
    var chain = Promise.resolve();
    keys.forEach(function(key) {
      chain = chain.then(function() {
        var b = blobMap[key];
        var name = key + '.' + extFromMime(b && b.type);
        return uploadBlobToShopifyCdn(b, name).then(function(urlOrBlob) {
          if (typeof urlOrBlob === 'string' && urlOrBlob.indexOf('cdn.shopify.com') !== -1) {
            results[key] = urlOrBlob;
          }
        });
      });
    });
    return chain.then(function() { return results; });
  }

  if (!customElements.get('product-form')) {
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!state.customizationComplete) {
          return;
        }

        var submitButton = this.querySelector('[type="submit"]');
        if (!submitButton) return;

        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');
        var spinnerEl = submitButton.querySelector('.vinyl-spinner');
        if (spinnerEl) spinnerEl.classList.remove('hidden');

        var statusEl = submitButton.querySelector('.vinyl-btn-status');
        if (!statusEl) {
          statusEl = document.createElement('span');
          statusEl.className = 'vinyl-btn-status';
          submitButton.appendChild(statusEl);
        }
        statusEl.textContent = 'Preparing your vinyl…';

        var self = this;

        var hasTextOverlays = !!(
          (state.coverText.A.text) || (state.coverText.A2.text) || (state.coverText.A3.text) ||
          (state.coverText.B.text) || (state.coverText.B2.text) || (state.coverText.B3.text) || (state.coverText.B4.text) ||
          (state.stickerText.A.text) || (state.stickerText.B.text)
        );

        console.log('[Vinyl] Has text overlays:', hasTextOverlays);
        if (hasTextOverlays) {
          console.log('[Vinyl] Cover A text:', state.coverText.A.text || '(none)');
          console.log('[Vinyl] Cover B text:', state.coverText.B.text || '(none)');
          console.log('[Vinyl] Sticker A text:', state.stickerText.A.text || '(none)');
          console.log('[Vinyl] Sticker B text:', state.stickerText.B.text || '(none)');
        }

        var compositingPromise = hasTextOverlays
          ? generateCompositedImages()
          : Promise.resolve({});

        compositingPromise
          .then(function(composited) {
            console.log('[Vinyl] Compositing done:', {
              coverA: composited.coverA ? (composited.coverA.size + ' bytes') : 'skip',
              coverB: composited.coverB ? (composited.coverB.size + ' bytes') : 'skip',
              stickerA: composited.stickerA ? (composited.stickerA.size + ' bytes') : 'skip',
              stickerB: composited.stickerB ? (composited.stickerB.size + ' bytes') : 'skip'
            });

            var uploadTasks = [];
            ['coverA', 'coverB', 'stickerA', 'stickerB'].forEach(function(key) {
              if (composited[key] && composited[key] instanceof Blob) {
                var fallbackName = key + '.' + extFromMime(composited[key].type);
                uploadTasks.push(
                  uploadBlobToFilestack(composited[key], composited[key].name || fallbackName)
                    .then(function(url) {
                      if (typeof url === 'string' && url.indexOf('://') !== -1) {
                        console.log('[Vinyl] ' + key + ' → Filestack:', url);
                        composited[key] = url;
                      }
                    })
                );
              }
            });

            if (uploadTasks.length) statusEl.textContent = 'Uploading images…';
            return Promise.all(uploadTasks).then(function() { return composited; });
          })
          .then(function(composited) {
            statusEl.textContent = 'Adding to cart…';
            var mainFormData = self.buildMainFormData(composited);
            var addonItems = self.buildAddonItems();

            return Promise.resolve().then(function() {

              return fetch('/cart/add', {
                method: 'POST',
                body: mainFormData
              })
              .then(function(res) {
                if (!res.ok && res.status >= 400 && res.status < 500) {
                  return res.text().then(function(txt) {
                    var match = txt.match(/description["\s:]+([^"<]+)/);
                    throw new Error(match ? match[1] : 'Could not add product to cart');
                  });
                }
                return res.text();
              })
              .then(function() {
                if (addonItems.length === 0) return Promise.resolve();
                statusEl.textContent = 'Adding extras…';
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: addonItems })
                }).then(function(res) {
                  if (!res.ok) {
                    console.warn('[Vinyl] Addon add failed, continuing to cart');
                    return;
                  }
                  return res.json();
                }).catch(function(e) {
                  console.warn('[Vinyl] Addon error (non-blocking):', e);
                });
              })
              .then(function() {
                try { sessionStorage.removeItem(STORAGE_KEY); } catch(e) {}
                window.location.href = '/cart';
              });
            });
          })
          .catch(function(err) {
            console.error('[Vinyl] Cart error:', err);
            self.handleError(err.message || 'Could not add to cart.');
            submitButton.removeAttribute('disabled');
            submitButton.classList.remove('loading');
            if (spinnerEl) spinnerEl.classList.add('hidden');
            statusEl.textContent = '';
          });
      }

      buildMainFormData(composited) {
        composited = composited || {};
        var variantInput = this.form.querySelector('[name="id"]');
        var variantId = variantInput ? variantInput.value : (config.variantId || '');
        var qtyInput = document.getElementById('vinyl-quantity-input');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        if (!variantId) throw new Error('No product variant found');

        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', qty);

        /* --- 1. Four composited images --- */
        var compositedMap = {
          1: composited.coverA || null,
          2: composited.coverB || null,
          3: composited.stickerA || null,
          4: composited.stickerB || null
        };

        var imageLabels = { 1: 'Front Cover', 2: 'Back Cover', 3: 'Side A Sticker', 4: 'Side B Sticker' };
        for (var idx in imageLabels) {
          var label = imageLabels[idx];
          var upload = state.uploadedFiles[idx];
          if (!upload) continue;

          var comp = compositedMap[idx];
          var uploadExt = extFromMime(upload.mime);
          if (comp && typeof comp === 'string' && comp.indexOf('://') !== -1) {
            fd.append('properties[' + label + ']', comp);
          } else if (comp && comp instanceof Blob) {
            fd.append('properties[' + label + ']', comp, comp.name || ('composited_' + idx + '.' + extFromMime(comp.type)));
          } else if (upload.fileUrl && !upload.fileUrl.startsWith('data:')) {
            fd.append('properties[' + label + ']', upload.fileUrl);
          } else if (upload.blob) {
            fd.append('properties[' + label + ']', upload.blob, upload.name || ('image_' + idx + '.' + uploadExt));
          } else {
            fd.append('properties[' + label + ']', 'Uploaded: ' + (upload.name || 'image') + (upload.resolution ? ' (' + upload.resolution + ')' : ''));
          }
        }

        /* --- 2. Record Type & Color --- */
        if (state.selectedRecord) {
          fd.append('properties[Record Type]', state.selectedRecord);
        }
        if (state.recordColor) {
          fd.append('properties[Record Color]', state.recordColor);
        }

        /* --- 3. Tracklists & Audio (PrintYourVinyl method) --- */
        console.log('[Vinyl] uploadMode:', state.uploadMode);

        ['A', 'B'].forEach(function(side) {
          var tracks = state.tracks[side];
          if (!tracks || !tracks.length) return;

          var trackLines = tracks.map(function(t, i) {
            return (i + 1) + '. ' + t.name + ' (' + (t.durationStr || '0:00') + ')';
          }).join('\n');
          fd.append('properties[Side ' + side + ' Tracklist]', trackLines);

          tracks.forEach(function(t, i) {
            if (t.fileUrl && t.fileUrl.indexOf('://') !== -1) {
              fd.append('properties[Side ' + side + ' Audio ' + (i + 1) + ']', t.fileUrl);
              console.log('[Vinyl] Audio ' + side + (i+1) + ': CDN →', t.fileUrl);
            } else if (t.file && t.file instanceof File) {
              fd.append('properties[Side ' + side + ' Audio ' + (i + 1) + ']', t.file, t.file.name);
              console.log('[Vinyl] Audio ' + side + (i+1) + ': File blob');
            }
          });
        });

        /* --- 4. Audio Source --- */
        if (state.uploadMode) {
          fd.append('properties[Audio Source]', state.uploadMode === 'research' ? 'Find audio for me' : 'Own audio files');
        }

        /* --- 4b. Tracklist placement --- */
        var trackBackCb = document.getElementById('tracklistBack');
        var trackStickersCb = document.getElementById('tracklistStickers');
        if (trackBackCb && trackBackCb.checked) {
          fd.append('properties[Tracklist on Back Cover]', 'Yes');
        }
        if (trackStickersCb && trackStickersCb.checked) {
          fd.append('properties[Tracklist on Stickers]', 'Yes');
        }

        /* --- 5. Add-on Services --- */
        var addonDetails = [];
        document.querySelectorAll('.vinyl-addon input[type="checkbox"]:checked').forEach(function(cb) {
          var addonEl = cb.closest('.vinyl-addon');
          var lbl = addonEl ? addonEl.querySelector('label') : null;
          var priceVal = cb.dataset.value || '0';
          var name = lbl ? lbl.textContent.trim() : 'Add-on';
          addonDetails.push({ name: name, price: priceVal });
        });

        if (addonDetails.length) {
          var addonSummary = addonDetails.map(function(a) {
            return a.name + ' (+$' + a.price + ')';
          }).join(' | ');
          fd.append('properties[Add-on Services]', addonSummary);

          addonDetails.forEach(function(a, i) {
            fd.append('properties[Service ' + (i + 1) + ']', a.name + ' — $' + a.price);
          });
        }

        /* --- 6. Cover Text (Step 3) — only the text, styling is on the composited image --- */
        var coverLabels = {
          A: 'Front Cover Text 1', A2: 'Front Cover Text 2', A3: 'Front Cover Text 3',
          B: 'Back Cover Text 1', B2: 'Back Cover Text 2', B3: 'Back Cover Text 3', B4: 'Back Cover Text 4'
        };
        var coverKeys = ['A', 'A2', 'A3', 'B', 'B2', 'B3', 'B4'];
        coverKeys.forEach(function(key) {
          var ct = state.coverText[key];
          var domInput = document.getElementById('coverText' + key);
          var domValue = domInput ? domInput.value : '';
          if (domValue && domValue.trim()) {
            ct.text = domValue;
          }
          if (ct && ct.text && ct.text.trim()) {
            fd.append('properties[' + coverLabels[key] + ']', ct.text.trim());
          }
        });

        /* --- 7. Sticker Text (Step 5) — only the text --- */
        var stickerLabels = { A: 'Side A Sticker Text', B: 'Side B Sticker Text' };
        ['A', 'B'].forEach(function(key) {
          var st = state.stickerText[key];
          var domInput = document.getElementById('stickerText' + key);
          var domValue = domInput ? domInput.value : '';
          if (domValue && domValue.trim()) {
            st.text = domValue;
          }
          if (st && st.text && st.text.trim()) {
            fd.append('properties[' + stickerLabels[key] + ']', st.text.trim());
          }
        });

        /* --- 8. Etsy Order Number (Constructor 6 only) ---
           The input lives outside <form> and is wired via form="..." attribute,
           but we build FormData manually, so we must read & append it here.
           No-op for sections that don't have this field (e.g. C2). */
        var etsyInput = document.querySelector('input[name="properties[Etsy Order Number]"]');
        if (etsyInput && etsyInput.value && etsyInput.value.trim()) {
          fd.append('properties[Etsy Order Number]', etsyInput.value.trim());
        }

        return fd;
      }

      buildAddonItems() {
        var qtyInput = document.getElementById('vinyl-quantity-input');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var items = [];

        document.querySelectorAll('.vinyl-addon input[type="checkbox"]:checked').forEach(function(cb) {
          var addonVariantId = cb.dataset.variantId || cb.dataset.variant_id;
          if (addonVariantId) {
            items.push({
              id: parseInt(addonVariantId, 10),
              quantity: qty,
              properties: { '_hidden': 'true' }
            });
          }
        });

        return items;
      }

      handleError(message) {
        var errorWrapper = this.querySelector('.vinyl-product-form__error');
        var errorMsg = this.querySelector('.vinyl-product-form__error-msg');
        if (errorWrapper && errorMsg) {
          errorMsg.textContent = message;
          errorWrapper.removeAttribute('hidden');
          errorWrapper.style.display = '';
          setTimeout(function() {
            errorWrapper.setAttribute('hidden', '');
            errorWrapper.style.display = 'none';
          }, 5000);
        }
      }
    }

    customElements.define('product-form', ProductForm);
  }

  /* ==========================================================================
     CUSTOM ELEMENT: quantity-input
     ========================================================================== */
  if (!customElements.get('quantity-input')) {
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
      }
    }
    customElements.define('quantity-input', QuantityInput);
  }

  /* ==========================================================================
     BOOT
     ========================================================================== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    
  /* ==========================================================================
     MOBILE: Move services+FAQ after info column
     ========================================================================== */
  function repositionForMobile() {
    var media = document.querySelector('.vinyl-product__media');
    var info = document.querySelector('.vinyl-product__info');
    var services = document.querySelector('.vinyl-services');
    var faq = document.querySelector('.vinyl-faq');
    if (!media || !info || !services) return;

    var isMobile = window.innerWidth < 750;

    if (isMobile && services.parentNode === media) {
      info.after(services);
      if (faq) services.after(faq);
    } else if (!isMobile && services.parentNode !== media) {
      media.appendChild(services);
      if (faq) media.appendChild(faq);
    }
  }

  window.addEventListener('resize', function() {
    repositionForMobile();
  });

  repositionForMobile();

  /* ==========================================================================
     Custom Font-Size Dropdowns — replace native <select> with scrollable UI
     ========================================================================== */
  function initCustomFontSizeDropdowns() {
    var selects = document.querySelectorAll('.vinyl-fontsize-select');
    selects.forEach(function(sel) {
      if (sel.closest('.vinyl-custom-select')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'vinyl-custom-select';

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'vinyl-custom-select__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      var selectedOpt = sel.options[sel.selectedIndex];
      trigger.textContent = selectedOpt ? selectedOpt.text : '';

      var dropdown = document.createElement('div');
      dropdown.className = 'vinyl-custom-select__dropdown';
      dropdown.setAttribute('role', 'listbox');

      Array.from(sel.options).forEach(function(opt) {
        var item = document.createElement('div');
        item.className = 'vinyl-custom-select__option';
        if (opt.selected) item.classList.add('vinyl-custom-select__option--selected');
        item.setAttribute('role', 'option');
        item.setAttribute('data-value', opt.value);
        item.textContent = opt.text;

        item.addEventListener('click', function(e) {
          e.stopPropagation();
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          trigger.textContent = opt.text;
          dropdown.querySelectorAll('.vinyl-custom-select__option').forEach(function(o) {
            o.classList.remove('vinyl-custom-select__option--selected');
          });
          item.classList.add('vinyl-custom-select__option--selected');
          wrapper.classList.remove('vinyl-custom-select--open');
          trigger.setAttribute('aria-expanded', 'false');
        });

        dropdown.appendChild(item);
      });

      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = wrapper.classList.contains('vinyl-custom-select--open');

        document.querySelectorAll('.vinyl-custom-select--open').forEach(function(w) {
          w.classList.remove('vinyl-custom-select--open');
          w.querySelector('.vinyl-custom-select__trigger').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          wrapper.classList.add('vinyl-custom-select--open');
          trigger.setAttribute('aria-expanded', 'true');
          var selectedItem = dropdown.querySelector('.vinyl-custom-select__option--selected');
          if (selectedItem) {
            selectedItem.scrollIntoView({ block: 'nearest' });
          }
        }
      });

      sel.parentNode.insertBefore(wrapper, sel);
      wrapper.appendChild(sel);
      wrapper.appendChild(trigger);
      wrapper.appendChild(dropdown);

      var observer = new MutationObserver(function() {
        var curOpt = sel.options[sel.selectedIndex];
        if (curOpt) {
          trigger.textContent = curOpt.text;
          dropdown.querySelectorAll('.vinyl-custom-select__option').forEach(function(o) {
            o.classList.toggle('vinyl-custom-select__option--selected',
              o.getAttribute('data-value') === sel.value);
          });
        }
      });
      observer.observe(sel, { attributes: true, childList: true, subtree: true });

      sel.addEventListener('change', function() {
        var curOpt = sel.options[sel.selectedIndex];
        if (curOpt) {
          trigger.textContent = curOpt.text;
          dropdown.querySelectorAll('.vinyl-custom-select__option').forEach(function(o) {
            o.classList.toggle('vinyl-custom-select__option--selected',
              o.getAttribute('data-value') === sel.value);
          });
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.vinyl-custom-select')) {
        document.querySelectorAll('.vinyl-custom-select--open').forEach(function(w) {
          w.classList.remove('vinyl-custom-select--open');
          w.querySelector('.vinyl-custom-select__trigger').setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  initCustomFontSizeDropdowns();

  init();
  }
})();
